// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T23:00:37.609Z
// Property: West 39th Street Apartments (ID: 6767906449167623)
// Collections: 21 amenities, 9 floorplans (live), 27 photos, 77 POIs, 2 reviews, 8 virtual tours, 5 office hours, 1 special offers (live), 16 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162465",
  "multihub_property_id": "6767906449167623",
  "property_external_id": "1124407",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/west-39th-street-kansas-city-mo/ewhlf0p/",
  "property_google_business_url": "https://www.google.com/maps/place/West+39th+Street+Apartment+Homes/@39.0576345,-94.6070828,1777m/data=!3m2!1e3!4b1!4m6!3m5!1s0x87c0ee2c6558c2b7:0xd8e6434d497d96b8!8m2!3d39.0576345!4d-94.6070828!16s%2Fg%2F1jky1qb0q?entry=ttu&g_ep=EgoyMDI2MDkxNi4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "1124407 p1099358",
  "property_status": null,
  "property_slug": "west-39th-street-apartments",
  "property_name": "West 39th Street Apartments",
  "property_website_url": "https://www.west39th.com/",
  "property_domain": "https://www.west39th.com/",
  "property_address": "3895 State Line Rd",
  "property_full_address": "3895 State Line Rd, Kansas City, MO 64111",
  "property_address_1": "3895 State Line Rd",
  "property_address_2": null,
  "property_address_city": "Kansas City",
  "property_address_state": "MO",
  "property_address_zip_full": null,
  "property_address_zip": "64111",
  "property_address_country": "US",
  "property_address_county": "Jackson County",
  "property_neighborhood_address": "Midtown - Westport",
  "property_address_latitude": "39.0576826",
  "property_address_longitude": "-94.60697850000001",
  "property_email": "rentcafe.w39@pricekc.com",
  "property_phone": "(816) 852-3257",
  "property_call_tracking_phone": "816-852-3257",
  "property_company_name": "Price Brothers",
  "property_company_url": "https://www.pricebrotherskc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Midtown energy meets everyday ease</strong> at West 39th Street Apartments, where polished one- and two-bedroom <a href=\"/floor-plans\">floor plans</a>, included garage parking, and walkable access to KC dining, coffee, and boutiques make home feel connected from the start. <a href=\"/schedule-a-tour\">Schedule a tour</a> today.</p>",
  "property_long_description": "<p><strong>Live where Midtown energy meets everyday ease.</strong> At West 39th Street Apartments, you’re positioned along one of Kansas City’s most walkable, character-rich corridors—steps from the West 39th District, KU Medical Center, and the local dining, coffee, and boutique scene that gives this neighborhood its unmistakable rhythm.</p><p>Choose from thoughtfully designed one- and two-bedroom <a href=\"/floor-plans\">floor plans</a> with polished finishes like granite countertops, kitchen islands, dark wood cabinetry, 11-foot ceilings, built-in desks, walk-in closets, and in-home washer and dryer. Beyond your front door, <a href=\"/amenities\">community amenities</a> such as controlled access, included garage parking, a fitness center, business center, package service, and an outdoor lounge with grilling space help simplify your day.</p><p>From Room 39, Jazz, Q39, Prospero’s Books, and Roanoke Park to Westport, the Country Club Plaza, and Downtown Kansas City, your <a href=\"/neighborhood\">Midtown-Westport neighborhood</a> keeps the best of KC close, connected, and easy to explore.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b678-0571-72ee-9eb2-d1f4e490b7d4.webp",
  "property_featured_image_media": {
    "alt_text": "Modern kitchen with dark wood cabinets, granite island, stainless steel appliances, and a view of the front door.",
    "public_id": "01a0b678-0571-72ee-9eb2-d1f4e490b7d4",
    "storage_key": "property/6767906449167623/01a0b678-0571-72ee-9eb2-d1f4e490b7d4.webp",
    "width": 1200,
    "height": 800
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "71",
  "property_year_built": "2013",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "92.95774647887323",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $175-275",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.",
  "property_pet_policy_description": "The non-refundable fee is $300 for 1 pet, and $500 for 2 pets.",
  "property_petpolicy_info": "https://www.pricebrotherskc.com/petroyaltyclub/",
  "property_online_leasing_url": "https://west39th.securecafeapplicant.com/onlineleasing/content3/access/west-39th-street/floorplans",
  "property_resident_portal_url": "https://west39th.securecafe.com/residentservices/west-39th-street/userlogin.aspx",
  "property_apply_now_url": "https://west39th.securecafeapplicant.com/onlineleasing/content3/access/west-39th-street/login",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b670-04bb-73be-b4fb-f25a644d227b.webp",
  "property_primary_logo_media": {
    "alt_text": "39th logo",
    "public_id": "01a0b670-04bb-73be-b4fb-f25a644d227b",
    "storage_key": "property/6767906449167623/01a0b670-04bb-73be-b4fb-f25a644d227b.webp",
    "width": 1500,
    "height": 579
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b670-04bb-73be-b4fb-f25a644d227b.webp",
  "property_mono_white_logo_media": {
    "alt_text": "39th logo",
    "public_id": "01a0b670-04bb-73be-b4fb-f25a644d227b",
    "storage_key": "property/6767906449167623/01a0b670-04bb-73be-b4fb-f25a644d227b.webp",
    "width": 1500,
    "height": 579
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b670-9169-7695-92a3-f6e18e9c8787.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a0b670-9169-7695-92a3-f6e18e9c8787",
    "storage_key": "property/6767906449167623/01a0b670-9169-7695-92a3-f6e18e9c8787.webp",
    "width": 1280,
    "height": 494
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a0d9b7-62d2-753a-a137-bd690ff6733b.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff68a-de80-741a-9687-3e84c8c517e3.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#e87722",
  "property_secondary_color": "#425563",
  "property_font_color": null,
  "property_color_4": "#B9314F",
  "property_color_3": "#d9c756",
  "property_color_5": "#75B9BE",
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "598 - 1040",
  "property_sqft_min": "598",
  "property_sqft_max": "1040",
  "property_price_range": "1372 - 7980",
  "property_price_min": "1372",
  "property_price_max": "7980",
  "property_available_units": 5,
  "property_facebook_url": "https://www.facebook.com/West39thKC",
  "property_instagram_url": "https://www.instagram.com/west39thkc/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJt8JYZSzuwIcRuJZ9SU1D5tg",
  "property_youtube_url": "https://www.youtube.com/user/Pricebrothersmgt",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to West 39th Street Apartments",
  "property_home_romance_title": "Embrace the Joy of Living in Your Dream Apartment",
  "property_home_amenities_blurb": "<p><strong>Polished amenities, Midtown-Westport ease.</strong> West 39th Street Apartments pairs 11-foot ceilings, granite countertops, dark wood cabinetry, kitchen islands, wood blinds, and in-home washer/dryer convenience with thoughtful community perks. Enjoy controlled access, garage parking, package and dry cleaning services, Wi-Fi in shared spaces, a fitness center, business center with printer, courtyard lounge, grilling area, sundeck, and bark park—then see even more on the full Amenities page.</p>",
  "property_home_floorplans_blurb": "<p><strong>Floor plans with polish and flexibility.</strong> West 39th Street Apartments offers one- and two-bedroom layouts with standout options like 11-foot ceilings, granite countertops, dark wood cabinetry, kitchen islands, built-in desks, walk-in closets, in-home laundry, and private den or study spaces in select homes. Some floor plans add a patio or balcony for an easy Midtown-Westport indoor-outdoor moment.</p>",
  "property_home_gallery_blurb": "<p><strong>Preview the details that set the tone.</strong> Browse bright kitchens with granite counters, dark wood cabinetry, and island seating, plus airy living spaces with 11-foot ceilings, warm flooring, wood blinds, and built-in desk moments. Then look outside to the courtyard lounge with string lights, pergola shade, grill stations, colorful seating, and an outdoor TV—all captured to give you a sharper sense of West 39th Street Apartments before you tour.</p>",
  "property_home_neighborhood_blurb": "<p>West 39th Street Apartments places you in the center of one of Kansas City's most dynamic neighborhoods, with the restaurants, such as Q39, Beirut Taco, and Kansas City’s famous Jazz, Cajun cuisine with live music. Stop for a drink at Hi-Dive or Goat &amp; Rabbit and explore everyday destinations of the 39th Street District.</p><p>KU Medical Center is just blocks from West 39th Street Apartments, and Truman Medical Center is also nearby.</p><p><br></p><p>The historic Westport neighborhood is also close by, with live music, locally owned restaurants, craft beverage destinations, and one of Kansas City's most celebrated entertainment corridors. Country Club Plaza, with its upscale shopping and dining, is a short distance away. The broader Midtown Kansas City area provides additional access to cultural destinations, parks, and the energy of one of the fastest-growing urban neighborhoods in the Midwest.</p><p><br></p><p>Explore the neighborhood map and see everything within reach of West 39th Street Apartments.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents have plenty to praise at West 39th Street Apartments.</strong> Reviews call out the friendly, professional team, quick maintenance, modern apartment style, and added everyday ease of a secured building with enclosed garage parking.</p><p>From spacious layouts to a convenient Midtown-Westport location, the feedback points to comfort, reliability, and attentive service—earning comments like “5 stars all the way!!!”</p>",
  "property_neighborhood_blurb": "<p><strong>Your map starts with momentum.</strong> From West 39th Street Apartments, you can move easily between Midtown flavor, Westport nightlife, and everyday stops without losing the neighborhood feel. Follow 39th for Meshuggah Bagels in the morning, Tiki Taco or Pizza Tascio later, and local originals tucked between murals, patios, and storefronts. Third Fridays bring music and pop-ups to the corridor, while nearby Roanoke Park gives you trails and green space when the day calls for fresh air. Need to go farther? RideKC’s 39 bus runs along the street, and the KC Streetcar’s Westport stop at 39th &amp; Main connects you with Main Street, the Plaza, Crossroads, Downtown, and the Riverfront. Explore the map, then <a href=\"/schedule-a-tour\">see the neighborhood in person</a>.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>The amenities at West 39th Street Apartments are built around how Midtown actually lives: outside, with friends, and on your own schedule.</p><p><br></p><p>The outdoor living plaza at West 39th Street Apartments is a defining feature of the community. An outdoor entertainment area, gas grills, and comfortable lounge seating create a social atmosphere perfect for watching the game or hosting friends on a warm Kansas City evening. If the plaza is busy, a second courtyard has more grilling stations so there’s always room to spread out. Inside, the fitness center is open 24/7, so you can fit in a workout on any schedule.</p><p><br></p><p>Included garage parking comes standard, which is rare in Midtown. The building also has controlled-access entry. When you need to get work done outside your apartment, there’s high-speed WiFi throughout the common areas and a business center with computers and printing.<strong> </strong></p><p><br></p><p>Inside every home at West 39th Street Apartments, 11-foot ceilings, hardwood floors, granite countertops, kitchen islands, in-unit washer and dryer, and walk-in closets deliver an upscale living experience from the moment you walk through the door. Flexible rent payment options and professional management complete the picture.</p><p>Explore the full amenity collection below.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Midtown easier?</strong><br>Apply online for West 39th Street Apartments and start your next chapter with polished one- and two-bedroom layouts, everyday conveniences, and a walkable Kansas City location close to the energy that defines West 39th.</p>",
  "property_contactus_blurb": "<p><strong>Questions? Need directions?</strong><br>Contact the West 39th Street Apartments leasing team for help exploring one- and two-bedroom floor plans, polished in-home finishes, and a Midtown-Westport location that keeps everyday essentials close. We’re here to make your next step simple.</p>",
  "property_faqs_blurb": "<p><strong>Questions about West 39th Street Apartments?</strong> Start here for quick answers about the community, leasing, amenities, and everyday life in this walkable Midtown-Westport setting. If you need more details, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Find your fit on West 39th.</strong> Browse one- and two-bedroom apartment floor plans designed to make everyday living feel streamlined, polished, and flexible. Choose a one-bedroom layout with room to settle in, or a two-bedroom, two-bath home that gives you added separation for hosting, working, or unwinding.</p><p>Inside, select homes bring together details that matter: <a href=\"/amenities\">11-foot ceilings</a>, granite countertops, dark wood cabinetry, kitchen islands, built-in desks, walk-in closets, in-home washer and dryer, and private den or study options. Some layouts add a patio or balcony for an easy indoor-outdoor moment in Midtown-Westport. Compare current pricing and availability, explore the layouts that match your routine, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see your next apartment in person.</p>",
  "property_gallery_blurb": "<p>Take a look inside West 39th Street Apartments. Browse photos of our one- and two-bedroom homes, community spaces, and outdoor areas to get a feel for everyday life on 39th Street.</p><p><br></p><p>Inside, tall ceilings and hardwood floors set the tone, and the kitchen island is where friends end up gathering. Downstairs, the outdoor lounge and courtyard grills are ready for game days and warm evenings with friends.</p><p><br></p><p>Photos only show so much. Schedule a tour and see it in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore West 39th from every angle.</strong><br>Use the interactive map to browse available apartments and see how this walkable Midtown-Westport address connects you to local dining, coffee, boutiques, parks, and the best of Kansas City nearby.</p>",
  "property_pets_blurb": "<p>West 39th Street Apartments is a pet-friendly community in Midtown Kansas City, welcoming cats and dogs so every member of your household feels at home. The nearby parks and green spaces around the 39th Street District offer plenty of options for outdoor time with your pets.</p><p><br></p><p>Up to two pets are permitted per apartment home. Monthly pet rent is $25 per pet, with a $300 non-refundable deposit for one pet or $500 total for two pets. Breed restrictions apply. Assistance animals are not considered pets and are not subject to pet fees or restrictions. Pets at West 39th Street Apartments are also members of the <a href=\"https://www.pricebrotherskc.com/petroyaltyclub/\" target=\"_blank\">Price Brothers Management Co. Pet Royalty Club</a>, which provides special discounts and offers at local pet-related businesses with payment of the one-time pet fee.</p>",
  "property_referafriend_blurb": "<p><strong>Share the Midtown energy.</strong> Love the walkable West 39th setting, polished apartment finishes, and everyday ease at West 39th Street Apartments? Invite a friend to explore the community and see how close, connected, and convenient Kansas City living can feel.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access made easy.</strong> From rent payments to maintenance requests and account updates, manage the everyday details of home at West 39th Street Apartments in one convenient place—so you can get back to the Midtown ease, polished finishes, and connected Kansas City lifestyle that define your address.</p>",
  "property_reviews_blurb": "<p><strong>See why residents recommend West 39th Street Apartments.</strong> Reviewers consistently praise the responsive team, quick maintenance, modern apartment style, and the everyday confidence that comes with a secured building and enclosed garage parking.</p><p>You’ll read about staff who are “friendly and professional,” service requests handled quickly, spacious layouts, and a location that makes daily routines feel easier in Midtown-Westport. From long-term residents to recent move-ins, the feedback points to a community experience built on reliability, comfort, and attentive service—one reviewer summed it up simply: “5 stars all the way!!!”</p>",
  "property_created_at": "1785792942562",
  "property_scheduletour_blurb": "<p>See West 39th Street Apartments for yourself. Schedule a guided or self-guided tour to explore our one- and two-bedroom apartment homes in the 39th Street District of Midtown Kansas City.</p><p><br></p><p>During your tour, explore apartment interiors featuring 11-foot ceilings, hardwood floors, kitchen islands, and an in-unit washer and dryer, and experience community spaces including the outdoor lounge with a 55-inch TV, fitness center, and included garage parking. Our leasing team will be available to answer questions about pricing, availability, and lease terms.</p><p><br></p><p>Choose a tour option below to plan your visit to West 39th Street Apartments.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong><br>Our leasing team will be in touch soon to help with your next step. In the meantime, picture life at West 39th Street Apartments, where Midtown energy meets everyday ease with walkable neighborhood access, polished <a href=\"/floor-plans\">one- and two-bedroom floor plans</a>, and thoughtful conveniences close to home.</p>",
  "property_virtualtours_blurb": null,
  "property_copyright": "2026 All Rights Reserved. West 39th Street Apartments",
  "property_seo_title_home": "West 39th Street Apartments | Westport Kansas City MO",
  "property_seo_description_home": "Luxury 1 & 2 bedroom apartments in Westport, Kansas City, MO. Outdoor lounge, fitness center & garage parking included. Steps from KU Med & Westport.",
  "property_seo_title_floorplans": "1 & 2 Bedroom Floor Plans | West 39th Street Kansas City",
  "property_seo_description_floorplans": "Browse 1 & 2 bedroom floor plans at West 39th Street Apartments in Kansas City. 11-ft ceilings, hardwood floors, granite countertops & washer/dryer included.",
  "property_seo_title_amenities": "Outdoor Lounge, Fitness & Garage Parking | Kansas City",
  "property_seo_description_amenities": "West 39th Street Apartments offers an outdoor lounge with 55\" TV, fitness center, garage parking, business center & limited access entry in Westport KC.",
  "property_seo_title_gallery": "Apartment Photos | West 39th Street Westport Kansas City",
  "property_seo_description_gallery": "Browse photos of West 39th Street Apartments in Westport, Kansas City — outdoor lounge, hardwood floors, fitness center & community spaces. See yourself here!",
  "property_seo_title_virtualtours": "Virtual Tours | West 39th Street Apartments Apartments",
  "property_seo_description_virtualtours": "Experience the charm of West 39th Street Apartments in Kansas City. Take a virtual tour of our unique one and two-bedroom homes today!",
  "property_seo_title_interactivemap": "Interactive Map | West 39th Street Apartments Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at West 39th Street Apartments! Enjoy luxury amenities, spacious layouts, and a lively Kansas City location.",
  "property_seo_title_neighborhood": "Westport Kansas City Neighborhood Guide | West 39th",
  "property_seo_description_neighborhood": "West 39th Street Apartments is steps from KU Medical Center, Westport nightlife, Country Club Plaza & the 39th Street District. Walk Score 91 in KC, MO.",
  "property_seo_title_contact": "Contact West 39th Street Apartments | Kansas City MO",
  "property_seo_description_contact": "Have questions about our apartments in Westport, Kansas City? Reach the West 39th Street Apartments team by phone or online. We'd love to help you!",
  "property_seo_title_faqs": "FAQs | Apartments in Kansas City, MO",
  "property_seo_description_faqs": "Get answers to your most pressing questions about West 39th Street Apartments. From amenities to living options, explore all you need to know today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Kansas City, MO",
  "property_seo_description_reviews": "Join the vibrant community at West 39th Street Apartments in Kansas City! Read resident reviews to discover why they love calling this place home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Kansas City, MO",
  "property_seo_description_applynow": "Discover comfort and style at West 39th Street Apartments, Kansas City. Enjoy modern amenities, spacious layouts, and a pet-friendly vibe. Lease now!",
  "property_seo_title_residentaccess": "Resident Access | West 39th Street Apartments",
  "property_seo_description_residentaccess": "Unlock convenient living at West 39th Street Apartments. Access your resident portal for easy rent payments, maintenance requests, and community updates today!",
  "property_seo_title_referafriend": "Refer A Friend | West 39th Street Apartments",
  "property_seo_description_referafriend": "Refer a friend to West 39th Street Apartments in Kansas City, MO! Great friends make the best neighbors. Share the joy of living in our vibrant community!",
  "property_seo_title_scheduletour": "Schedule a Tour | West 39th Street Apartments KC MO",
  "property_seo_description_scheduletour": "Ready to see West 39th Street Apartments in person? Schedule an in-person or virtual tour of our 1 & 2 bedroom apartments in Westport, Kansas City today!",
  "property_seo_title_privacy": "Privacy Policy | West 39th Street Apartments",
  "property_seo_description_privacy": "Protecting your information is our priority at West 39th Street Apartments. Read our privacy policy to see how we safeguard your data in Kansas City, MO.",
  "property_seo_title_accessibility": "Website Accessibility | West 39th Street Apartments",
  "property_seo_description_accessibility": "At West 39th Street Apartments in Kansas City, we embrace digital inclusion, ensuring an accessible experience for all. Join our community today!",
  "property_seo_title_sitemap": "Sitemap | West 39th Street Apartments",
  "property_seo_description_sitemap": "Navigate through West 39th Street Apartments in Kansas City, MO—your guide to stylish living. Check our sitemap for all the features and amenities we offer!",
  "property_seo_title_thankyou": "Thank You | West 39th Street Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out! Your journey to comfortable living at West 39th Street Apartments in Kansas City, MO, starts here. Expect to hear from us soon!",
  "property_seo_title_pets": "Pet-Friendly Apartments | West 39th Street Kansas City",
  "property_seo_description_pets": "West 39th Street Apartments welcomes cats & dogs in Westport, Kansas City, MO. Enjoy pet-friendly living & the Price Brothers Pet Royalty Club.",
  "property_updated_at": "1793743011508",
  "amenities": [
    {
      "id": "ec_b8fe2b2632f80fbc3f178f8c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "yardi",
      "external_id": "123604547",
      "title": "Near KU Medical Center",
      "amount": "false",
      "description": "Within walking distance of KU Med!",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b670-2932-75f6-adeb-26690c8d25e4.webp",
      "amenity_image_media": {
        "alt_text": "The University of Kansas Health System building exterior with blue glass facade.",
        "public_id": "01a0b670-2932-75f6-adeb-26690c8d25e4",
        "storage_key": "property/6767906449167623/01a0b670-2932-75f6-adeb-26690c8d25e4.webp",
        "width": 1200,
        "height": 900
      },
      "amenity_image_alt_text": "Outdoor at West 39th Street Apartments, Kansas City",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d983758b73b97a4d34c4ce09",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "yardi",
      "external_id": "88091629",
      "title": "Outdoor Lounge",
      "amount": "false",
      "description": "with Outdoor Kitchen, Gas Grill, and TV",
      "group": "Community",
      "is_featured": "1",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b678-3d81-7148-99cf-dd33aeb6dcbb.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor patio with seating, dining tables, umbrellas, and string lights.",
        "public_id": "01a0b678-3d81-7148-99cf-dd33aeb6dcbb",
        "storage_key": "property/6767906449167623/01a0b678-3d81-7148-99cf-dd33aeb6dcbb.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "Outdoor lounge at West 39th Street Apartments with pergola, string lights, dining tables, and mounted TV at West 39th Street Apartments, Missouri, 64111,Courtyard at West 39th Street Apartments featuring seating areas, greenery, and pergola with lights at dusk at West 39th Street Apartments, Missouri,Outdoor common area at West 39th Street Apartments with lounge furniture, string lights, and backdrop  at West 39th Street Apartments, Kansas City,Spacious courtyard at West 39th Street Apartments with multiple seating areas, pergola, and outdoor TV at West 39th Street Apartments, Kansas City, Missouri,Sunset view of the outdoor courtyard at West 39th Street Apartments with red cushioned lounge seating, pergola, and grilling station at West 39th Street Apartments, Kansas City, 64111",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_940108a6c71339a2ba5c8592",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "yardi",
      "external_id": "88091627",
      "title": "Garage Parking",
      "amount": "false",
      "description": "Price Included in Rent",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b678-2e8e-72ae-af85-83fc8fee4325.webp",
      "amenity_image_media": {
        "alt_text": "Covered parking garage entrance with a gray roll-up door and signage.",
        "public_id": "01a0b678-2e8e-72ae-af85-83fc8fee4325",
        "storage_key": "property/6767906449167623/01a0b678-2e8e-72ae-af85-83fc8fee4325.webp",
        "width": 1509,
        "height": 1006
      },
      "amenity_image_alt_text": "Garage at West 39th Street Apartments, Kansas City",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ece73e90608f3bb7c540ebe5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "yardi",
      "external_id": "88091630",
      "title": "State-Of-The-Art Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b678-22cf-71a8-80ea-5452ce5baac6.webp",
      "amenity_image_media": {
        "alt_text": "Well-equipped fitness center with cardio machines, weight machines, and benches.",
        "public_id": "01a0b678-22cf-71a8-80ea-5452ce5baac6",
        "storage_key": "property/6767906449167623/01a0b678-22cf-71a8-80ea-5452ce5baac6.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "Fully-equipped gym at West 39th Street Apartments with workout benches, cable machines, cardio stations, and ceiling fans at West 39th Street Apartments, Kansas City, Missouri,Spacious fitness center at West 39th Street Apartments featuring treadmills, ellipticals, recumbent bikes, free weights, and large wall mirrors at West 39th Street Apartments, Kansas City, 64111,Free weights, strength machines, and mounted TV in fitness center at West 39th Street Apartments at West 39th Street Apartments, Kansas City, MO, 64111",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a003c451f1992aa9ecc91575",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "yardi",
      "external_id": "88091625",
      "title": "Business Center",
      "amount": "false",
      "description": "Equipped with Computers, Printer, and Fax Machine",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b678-29fc-72ce-95dd-206ffffea59d.webp",
      "amenity_image_media": {
        "alt_text": "Business center with two workstations, each featuring a computer, desk lamp, and office chair. A printer/copier is located between the workstations.",
        "public_id": "01a0b678-29fc-72ce-95dd-206ffffea59d",
        "storage_key": "property/6767906449167623/01a0b678-29fc-72ce-95dd-206ffffea59d.webp",
        "width": 1750,
        "height": 1167
      },
      "amenity_image_alt_text": "Community business center with computer, printer, and fax machine at West 39th St Apartments in Midtown Westport, Kansas City.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_66c1265835cf8c298531e8ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "yardi",
      "external_id": "88091628",
      "title": "Limited Access Entry",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b678-2e1f-75fd-998c-26716ebe3627.webp",
      "amenity_image_media": {
        "alt_text": "Exterior entrance of the apartment building with brick facade and concrete stairs.",
        "public_id": "01a0b678-2e1f-75fd-998c-26716ebe3627",
        "storage_key": "property/6767906449167623/01a0b678-2e1f-75fd-998c-26716ebe3627.webp",
        "width": 1531,
        "height": 1020
      },
      "amenity_image_alt_text": "Exterior area at West 39th Street Apartments, Missouri",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2f571cff5396524656b2abaa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "yardi",
      "external_id": "88091631",
      "title": "Wi-Fi in Common Areas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_de5b4dfcbdf3f32baa21758a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "yardi",
      "external_id": "122755416",
      "title": "Flexible Rent Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ec7c2481debafe8ae0f28ba5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "yardi",
      "external_id": "88091641",
      "title": "Washer & Dryer Included",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b678-4335-7639-8289-5b7b085b8f8d.webp",
      "amenity_image_media": {
        "alt_text": "Living room with stacked washer and dryer and glimpse of bedroom",
        "public_id": "01a0b678-4335-7639-8289-5b7b085b8f8d",
        "storage_key": "property/6767906449167623/01a0b678-4335-7639-8289-5b7b085b8f8d.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "Washer & Dryer Included at West 39th Street Apartments, Kansas City",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_618ed40d1903b0ae443045c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "yardi",
      "external_id": "126014579",
      "title": "Private Den / Study*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b678-5698-76a6-8942-4b87f8c00d16.webp",
      "amenity_image_media": {
        "alt_text": "Home office with a white desk, laptop, and chair. View into living room.",
        "public_id": "01a0b678-5698-76a6-8942-4b87f8c00d16",
        "storage_key": "property/6767906449167623/01a0b678-5698-76a6-8942-4b87f8c00d16.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "A private study or den with a large window and ceiling fan at West 39th St Apartments in Midtown Westport, Kansas City, MO.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_59dcaa6d12e917a91c835994",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "yardi",
      "external_id": "88091635",
      "title": "Built-In Desk*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b678-4047-7287-8bd6-d7d8c199750c.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a breakfast bar with stools.",
        "public_id": "01a0b678-4047-7287-8bd6-d7d8c199750c",
        "storage_key": "property/6767906449167623/01a0b678-4047-7287-8bd6-d7d8c199750c.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "A kitchen with white bar stools and a granite countertop at West 39th Street Apartments, Kansas City",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c8e57069ec9a30bf1b9d28a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "yardi",
      "external_id": "88091637",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b678-60ee-70b5-8b1b-597329c929d6.webp",
      "amenity_image_media": {
        "alt_text": "Modern open-concept living and kitchen area with granite countertops, stainless steel appliances, and sectional sofa.",
        "public_id": "01a0b678-60ee-70b5-8b1b-597329c929d6",
        "storage_key": "property/6767906449167623/01a0b678-60ee-70b5-8b1b-597329c929d6.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "A modern kitchen with dark wood floors and white walls at West 39th Street Apartments, Kansas City, Missouri",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ce13777425c6ae2ff840bf35",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "yardi",
      "external_id": "88099894",
      "title": "Patio or Balcony*",
      "amount": "false",
      "description": "*with Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4d13f2bc0b0cf3be20262b17",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "yardi",
      "external_id": "88091636",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b678-67ee-71ca-a92c-f7493f496c84.webp",
      "amenity_image_media": {
        "alt_text": "Interior view of an apartment with kitchen and living area.",
        "public_id": "01a0b678-67ee-71ca-a92c-f7493f496c84",
        "storage_key": "property/6767906449167623/01a0b678-67ee-71ca-a92c-f7493f496c84.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "A kitchen with brown floors and white walls at West 39th Street Apartments, Kansas City, MO",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_30c2d0bc9577e756e385f1bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "yardi",
      "external_id": "88091638",
      "title": "Kitchen Island",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_50f382da33d1f77c4c20a08e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "yardi",
      "external_id": "88091632",
      "title": "Wood Blinds",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3268098d8d707074c7347c1f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "yardi",
      "external_id": "88091634",
      "title": "Dark Wood Cabinets with Brushed Nickel Hardware",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6e6ff02bad35819b9346542d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "yardi",
      "external_id": "88091639",
      "title": "Side-by-Side Refrigerator with Ice Maker",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_69e49807e6a7578d8ce8a653",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "yardi",
      "external_id": "88091640",
      "title": "Large Shower & Soaking Tub",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b678-6cc7-7068-9588-8e8c2d71e4cf.webp",
      "amenity_image_media": {
        "alt_text": "Modern bathroom with double vanity, granite countertops, and a bathtub with shower curtain.",
        "public_id": "01a0b678-6cc7-7068-9588-8e8c2d71e4cf",
        "storage_key": "property/6767906449167623/01a0b678-6cc7-7068-9588-8e8c2d71e4cf.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "A bathroom with brown cabinets and a marble countertop at West 39th Street Apartments, Missouri, 64111,A bathroom with a marble countertop and a large mirror at West 39th Street Apartments, Missouri",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_82a5f74c384ef45ecf6f7c63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "yardi",
      "external_id": "88091633",
      "title": "11-foot Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2e5bd9c3b68eacc530d58114",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "yardi",
      "external_id": "88099638",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b678-8616-713e-976b-135d3284628e.webp",
      "amenity_image_media": {
        "alt_text": "Closet with hanging clothes and shelves.",
        "public_id": "01a0b678-8616-713e-976b-135d3284628e",
        "storage_key": "property/6767906449167623/01a0b678-8616-713e-976b-135d3284628e.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "Clothes hanging on a clothes rack at West 39th Street Apartments, Kansas City, MO, 64111",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_12732478bc329d47c5cd5f6c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b678-0571-72ee-9eb2-d1f4e490b7d4.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite island, stainless steel appliances, and a view of the front door.",
        "public_id": "01a0b678-0571-72ee-9eb2-d1f4e490b7d4",
        "storage_key": "property/6767906449167623/01a0b678-0571-72ee-9eb2-d1f4e490b7d4.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring dark wood cabinetry, granite countertops, a spacious island with seating, and stainless steel appliances, opening to the entryway.",
      "link": "false",
      "alt_text": "Modern kitchen with dark wood cabinets, granite island, stainless steel appliances, and a view of the front door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/32-DSC01482_final.jpg"
    },
    {
      "id": "ec_c17c37dceb7fead291dfac12",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b678-9708-72ee-91bc-2b389ef0b980.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living area with island, sofa, and balcony access.",
        "public_id": "01a0b678-9708-72ee-91bc-2b389ef0b980",
        "storage_key": "property/6767906449167623/01a0b678-9708-72ee-91bc-2b389ef0b980.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed apartment featuring a spacious kitchen with a granite island, perfect for casual dining. The adjacent living area offers a comfortable space to relax and entertain, with large windows providing ample natural light.",
      "link": "false",
      "alt_text": "Modern kitchen and living area with island, sofa, and balcony access.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/08-DSC01312_final.jpg"
    },
    {
      "id": "ec_adc9bd8e110801b0208da063",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b678-addf-741c-be3a-a77950ee5fa5.webp",
      "image_media": {
        "alt_text": "Living room with a sectional sofa, coffee table, and TV, with a doorway to a bedroom and a washer/dryer closet.",
        "public_id": "01a0b678-addf-741c-be3a-a77950ee5fa5",
        "storage_key": "property/6767906449167623/01a0b678-addf-741c-be3a-a77950ee5fa5.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Relax in style in this spacious living area featuring a comfortable sectional sofa, modern entertainment center, and convenient in-unit washer and dryer.",
      "link": "false",
      "alt_text": "Living room with a sectional sofa, coffee table, and TV, with a doorway to a bedroom and a washer/dryer closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/11-DSC01332_final.jpg"
    },
    {
      "id": "ec_249b2a4b85f6f5052d14018c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b678-adbd-777b-88ec-ce72cafa90e4.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living area with island, sofa, TV, and desk.",
        "public_id": "01a0b678-adbd-777b-88ec-ce72cafa90e4",
        "storage_key": "property/6767906449167623/01a0b678-adbd-777b-88ec-ce72cafa90e4.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious and modern apartment featuring an open-concept living and kitchen area with a large island, comfortable sofa, entertainment center, and dedicated workspace.",
      "link": "false",
      "alt_text": "Modern kitchen and living area with island, sofa, TV, and desk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/05-DSC01287_final.jpg"
    },
    {
      "id": "ec_4ada7e837f6ca7c765fdfdb5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b678-add9-70a9-8dfa-690315865940.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island and wine fridge",
        "public_id": "01a0b678-add9-70a9-8dfa-690315865940",
        "storage_key": "property/6767906449167623/01a0b678-add9-70a9-8dfa-690315865940.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Beautifully appointed kitchen featuring granite countertops, stainless steel appliances, and a built-in wine refrigerator.",
      "link": "false",
      "alt_text": "Modern kitchen with island and wine fridge",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/02-DSC01273_alt_final.jpg"
    },
    {
      "id": "ec_39f29356ec09e17ffd6286ef",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b678-adb5-702b-810b-7a5f7c00e6ac.webp",
      "image_media": {
        "alt_text": "Modern living room and kitchen with island seating, dark cabinets, stainless steel appliances, and contemporary art.",
        "public_id": "01a0b678-adb5-702b-810b-7a5f7c00e6ac",
        "storage_key": "property/6767906449167623/01a0b678-adb5-702b-810b-7a5f7c00e6ac.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Experience open-concept living with a spacious layout featuring a gourmet kitchen, comfortable living area, and elegant finishes. Perfect for entertaining.",
      "link": "false",
      "alt_text": "Modern living room and kitchen with island seating, dark cabinets, stainless steel appliances, and contemporary art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/13-DSC01347_final.jpg"
    },
    {
      "id": "ec_01980f0071864e111d148987",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b678-b590-737b-b135-3f8069fe234e.webp",
      "image_media": {
        "alt_text": "Modern kitchen and dining area with a granite island and bar stools, built-in desk, and stainless steel appliances.",
        "public_id": "01a0b678-b590-737b-b135-3f8069fe234e",
        "storage_key": "property/6767906449167623/01a0b678-b590-737b-b135-3f8069fe234e.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring granite countertops, stainless steel appliances, and ample cabinet space, perfect for cooking and entertaining. Includes a dedicated workspace.",
      "link": "false",
      "alt_text": "Modern kitchen and dining area with a granite island and bar stools, built-in desk, and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/01-DSC01273_final.jpg"
    },
    {
      "id": "ec_ab5ee33893ed126177bf30bc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b678-ba57-75e7-8094-c03ec2462fe0.webp",
      "image_media": {
        "alt_text": "Luxurious bedroom with a king-size bed, plush bedding, and a walk-in closet.",
        "public_id": "01a0b678-ba57-75e7-8094-c03ec2462fe0",
        "storage_key": "property/6767906449167623/01a0b678-ba57-75e7-8094-c03ec2462fe0.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Experience ultimate comfort in our spacious bedrooms, featuring elegant decor and ample closet space for all your needs.",
      "link": "false",
      "alt_text": "Luxurious bedroom with a king-size bed, plush bedding, and a walk-in closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/26-DSC01442_final.jpg"
    },
    {
      "id": "ec_57049435c626e09642beaf32",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b678-ba85-77ff-b4a3-2939c170a168.webp",
      "image_media": {
        "alt_text": "A stylish home office with a white desk, laptop, and chair near a large window.",
        "public_id": "01a0b678-ba85-77ff-b4a3-2939c170a168",
        "storage_key": "property/6767906449167623/01a0b678-ba85-77ff-b4a3-2939c170a168.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Create your perfect home office in this bright and airy space, complete with a modern desk and comfortable seating.",
      "link": "false",
      "alt_text": "A stylish home office with a white desk, laptop, and chair near a large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/41-DSC01532_final.jpg"
    },
    {
      "id": "ec_7574848275444fae3b8684cd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b678-babd-730a-9009-7c0bf2d7222d.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, TV, and accent chair.",
        "public_id": "01a0b678-babd-730a-9009-7c0bf2d7222d",
        "storage_key": "property/6767906449167623/01a0b678-babd-730a-9009-7c0bf2d7222d.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sofa, modern coffee table, and entertainment center. An accent chair adds a pop of color. Large doors lead to a balcony.",
      "link": "false",
      "alt_text": "Living room with a sofa, coffee table, TV, and accent chair.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/36-DSC01512_final.jpg"
    },
    {
      "id": "ec_e70b6ebcea67fc51df529c16",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b678-bb23-706a-9df7-6910b69abda4.webp",
      "image_media": {
        "alt_text": "Spacious bedroom with a king-size bed, nightstand, ceiling fan, and abstract art.",
        "public_id": "01a0b678-bb23-706a-9df7-6910b69abda4",
        "storage_key": "property/6767906449167623/01a0b678-bb23-706a-9df7-6910b69abda4.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Relax in this beautifully appointed bedroom, featuring a comfortable king-size bed, modern ceiling fan, and elegant decor. An en-suite bathroom is accessible for your convenience.",
      "link": "false",
      "alt_text": "Spacious bedroom with a king-size bed, nightstand, ceiling fan, and abstract art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/43-DSC01571_final.jpg"
    },
    {
      "id": "ec_fd7d5e6631f1bacfa2a4dc54",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b678-d4de-7026-b785-1c3952824655.webp",
      "image_media": {
        "alt_text": "Bathroom with double vanity, granite countertops, and tiled floors.",
        "public_id": "01a0b678-d4de-7026-b785-1c3952824655",
        "storage_key": "property/6767906449167623/01a0b678-d4de-7026-b785-1c3952824655.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Elegant bathroom featuring a spacious double vanity with granite countertops, modern fixtures, and a bathtub with a decorative shower curtain.",
      "link": "false",
      "alt_text": "Bathroom with double vanity, granite countertops, and tiled floors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/20-DSC01382_final.jpg"
    },
    {
      "id": "ec_69503380bebb18b41f46f3f1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b678-dcc9-70f6-9c01-c70f6b0ccd01.webp",
      "image_media": {
        "alt_text": "View of bedroom through open bathroom door with vanity and granite countertop.",
        "public_id": "01a0b678-dcc9-70f6-9c01-c70f6b0ccd01",
        "storage_key": "property/6767906449167623/01a0b678-dcc9-70f6-9c01-c70f6b0ccd01.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom featuring a granite countertop vanity and a view into the bedroom.",
      "link": "false",
      "alt_text": "View of bedroom through open bathroom door with vanity and granite countertop.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/48-DSC01612_final.jpg"
    },
    {
      "id": "ec_74f309d082f74460f017b2e2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b678-dc6b-752e-856d-54a73608fefc.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area of an apartment with a sectional sofa, coffee table, TV, and kitchen island with bar stools.",
        "public_id": "01a0b678-dc6b-752e-856d-54a73608fefc",
        "storage_key": "property/6767906449167623/01a0b678-dc6b-752e-856d-54a73608fefc.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious living room and open-concept kitchen featuring a comfortable sectional sofa, a sleek coffee table, a modern entertainment center with a large TV, and a stylish kitchen island with bar stools.",
      "link": "false",
      "alt_text": "Living room and kitchen area of an apartment with a sectional sofa, coffee table, TV, and kitchen island with bar stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/38-DSC01516_final.jpg"
    },
    {
      "id": "ec_dc8ec7f309d72b42872f8eee",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b678-c998-7543-9960-2cf802cd24da.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-sized bed, dresser, and two doors leading to other rooms.",
        "public_id": "01a0b678-c998-7543-9960-2cf802cd24da",
        "storage_key": "property/6767906449167623/01a0b678-c998-7543-9960-2cf802cd24da.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-sized bed, a stylish dresser, and convenient access to an en-suite bathroom and another living area.",
      "link": "false",
      "alt_text": "Bedroom with a king-sized bed, dresser, and two doors leading to other rooms.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/17-DSC01372_final.jpg"
    },
    {
      "id": "ec_704a7f4bdbf657924b533ab5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b678-cb17-755d-a5c2-e74fc84dc3a2.webp",
      "image_media": {
        "alt_text": "Modern bathroom with granite countertop, vanity, toilet, and glass-enclosed shower.",
        "public_id": "01a0b678-cb17-755d-a5c2-e74fc84dc3a2",
        "storage_key": "property/6767906449167623/01a0b678-cb17-755d-a5c2-e74fc84dc3a2.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Experience comfort and style in our beautifully appointed bathrooms, featuring granite countertops, modern vanities, and sleek glass-enclosed showers.",
      "link": "false",
      "alt_text": "Modern bathroom with granite countertop, vanity, toilet, and glass-enclosed shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/30-DSC01477_final.jpg"
    },
    {
      "id": "ec_bf6510607ee6a634964e62e4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b678-d390-774d-8743-e52326187e8a.webp",
      "image_media": {
        "alt_text": "Walk-in closet with organized clothes on hangers.",
        "public_id": "01a0b678-d390-774d-8743-e52326187e8a",
        "storage_key": "property/6767906449167623/01a0b678-d390-774d-8743-e52326187e8a.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving and hanging space for your wardrobe.",
      "link": "false",
      "alt_text": "Walk-in closet with organized clothes on hangers.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/23-DSC01407_final.jpg"
    },
    {
      "id": "ec_addac6ffeedeef37d83b594b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b678-ec98-73ca-bd63-96cb9e5cf645.webp",
      "image_media": {
        "alt_text": "Aerial view of a modern apartment building at sunset with a city skyline in the background.",
        "public_id": "01a0b678-ec98-73ca-bd63-96cb9e5cf645",
        "storage_key": "property/6767906449167623/01a0b678-ec98-73ca-bd63-96cb9e5cf645.webp",
        "width": 1200,
        "height": 900
      },
      "title": "Community",
      "description": "Experience urban living at its finest with this stunning aerial view of our apartment community, set against a breathtaking sunset and a vibrant cityscape.",
      "link": "false",
      "alt_text": "Aerial view of a modern apartment building at sunset with a city skyline in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/3-DJI_20250402161139_0670_D-Edit-dte.jpg"
    },
    {
      "id": "ec_915ff79b347bc5728fb0b00b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b678-dd2a-703a-aede-7cb72fd57e7c.webp",
      "image_media": {
        "alt_text": "West 39th apartment building exterior at sunset",
        "public_id": "01a0b678-dd2a-703a-aede-7cb72fd57e7c",
        "storage_key": "property/6767906449167623/01a0b678-dd2a-703a-aede-7cb72fd57e7c.webp",
        "width": 1200,
        "height": 900
      },
      "title": "Community",
      "description": "Modern apartment building exterior with balconies and large windows, set against a vibrant sunset sky.",
      "link": "false",
      "alt_text": "West 39th apartment building exterior at sunset",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/2-DJI_20250402161037_0665_D-Edit-dte.jpg"
    },
    {
      "id": "ec_254870046acffc946387f4fd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b679-0177-73ec-be96-70580fa0a5c7.webp",
      "image_media": {
        "alt_text": "Courtyard seating area with outdoor kitchen and fire pit",
        "public_id": "01a0b679-0177-73ec-be96-70580fa0a5c7",
        "storage_key": "property/6767906449167623/01a0b679-0177-73ec-be96-70580fa0a5c7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed courtyard, featuring comfortable seating, an outdoor kitchen with grill, and a cozy fire pit area, perfect for social gatherings.",
      "link": "false",
      "alt_text": "Courtyard seating area with outdoor kitchen and fire pit",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/15-DSC01799-Edit-dte.jpg"
    },
    {
      "id": "ec_af14e961ae77b6be36d988d1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b679-3440-72ba-b71f-01ec861272c2.webp",
      "image_media": {
        "alt_text": "Outdoor patio with seating, tables, and a pergola with string lights.",
        "public_id": "01a0b679-3440-72ba-b71f-01ec861272c2",
        "storage_key": "property/6767906449167623/01a0b679-3440-72ba-b71f-01ec861272c2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the outdoors in our beautifully designed community patio, complete with comfortable seating, dining areas, and a shaded pergola with ambient lighting.",
      "link": "false",
      "alt_text": "Outdoor patio with seating, tables, and a pergola with string lights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/17-DSC01968-Edit-dte.jpg"
    },
    {
      "id": "ec_e826524160c05f17f704a542",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b679-1ee6-72fa-b3cb-97434fa68cc8.webp",
      "image_media": {
        "alt_text": "Courtyard with outdoor seating, bar area, and string lights at dusk.",
        "public_id": "01a0b679-1ee6-72fa-b3cb-97434fa68cc8",
        "storage_key": "property/6767906449167623/01a0b679-1ee6-72fa-b3cb-97434fa68cc8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Experience upscale living with our beautifully designed courtyard, featuring a full outdoor kitchen and bar, perfect for entertaining guests.",
      "link": "false",
      "alt_text": "Courtyard with outdoor seating, bar area, and string lights at dusk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/18-DSC02018-Edit-dte.jpg"
    },
    {
      "id": "ec_d651c0c2d1084059529af8f7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b679-0a80-74ec-84fd-a3963957b60a.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with seating, tables, and grills under a pergola with string lights.",
        "public_id": "01a0b679-0a80-74ec-84fd-a3963957b60a",
        "storage_key": "property/6767906449167623/01a0b679-0a80-74ec-84fd-a3963957b60a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and entertain in our outdoor lounge, featuring comfortable seating, dining areas, and grilling stations, perfect for enjoying the evening air.",
      "link": "false",
      "alt_text": "Outdoor lounge area with seating, tables, and grills under a pergola with string lights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/16-DSC01929-Edit-dte.jpg"
    },
    {
      "id": "ec_bea6182732b870ac6d54732e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b678-3d81-7148-99cf-dd33aeb6dcbb.webp",
      "image_media": {
        "alt_text": "Outdoor patio with seating, dining tables, umbrellas, and string lights.",
        "public_id": "01a0b678-3d81-7148-99cf-dd33aeb6dcbb",
        "storage_key": "property/6767906449167623/01a0b678-3d81-7148-99cf-dd33aeb6dcbb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the outdoors with our spacious patio area, featuring comfortable seating, dining tables, and ambient lighting.",
      "link": "false",
      "alt_text": "Outdoor patio with seating, dining tables, umbrellas, and string lights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/14-DSC01669-Edit-dte.jpg"
    },
    {
      "id": "ec_aa240ac3609754f6cb5241d4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b679-088d-734c-ae49-c01f35dddc07.webp",
      "image_media": {
        "alt_text": "Gym with weights and machines",
        "public_id": "01a0b679-088d-734c-ae49-c01f35dddc07",
        "storage_key": "property/6767906449167623/01a0b679-088d-734c-ae49-c01f35dddc07.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with free weights, weight machines, and cardio equipment.",
      "link": "false",
      "alt_text": "Gym with weights and machines",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/11-DSC02145.jpg"
    },
    {
      "id": "ec_b6d0efae49fd8714612a55f9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b678-22cf-71a8-80ea-5452ce5baac6.webp",
      "image_media": {
        "alt_text": "Well-equipped fitness center with cardio machines, weight machines, and benches.",
        "public_id": "01a0b678-22cf-71a8-80ea-5452ce5baac6",
        "storage_key": "property/6767906449167623/01a0b678-22cf-71a8-80ea-5452ce5baac6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a wide range of cardio and strength training equipment to help you achieve your wellness goals.",
      "link": "false",
      "alt_text": "Well-equipped fitness center with cardio machines, weight machines, and benches.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/10-DSC02139.jpg"
    },
    {
      "id": "ec_75b4c26fe2bd1ce17dfd599f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b679-4148-75c7-9bf3-e71a6d558415.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, weight machines, and free weights.",
        "public_id": "01a0b679-4148-75c7-9bf3-e71a6d558415",
        "storage_key": "property/6767906449167623/01a0b679-4148-75c7-9bf3-e71a6d558415.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with everything you need for a great workout.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, ellipticals, weight machines, and free weights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/09-DSC02119.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_eea4c98b-f348-4c68-a2d4-d8a6a0c8c781",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Room 39",
      "poi_type": "Restaurants",
      "poi_address": "1719 W 39th St, Kansas City, MO 64111, USA",
      "poi_short_description": "Offbeat eatery boasts a market-driven menu in a pared-down dining room with local art on the walls.",
      "poi_long_description": "Offbeat eatery boasts a market-driven menu in a pared-down dining room with local art on the walls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019fc993-2011-751e-a167-d0226fb6ef0f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-2011-751e-a167-d0226fb6ef0f",
        "storage_key": "property/6767906449167623/019fc993-2011-751e-a167-d0226fb6ef0f.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "http://www.rm39.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3381505156406471235&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "room-39",
      "poi_latitude": "39.0571096",
      "poi_longitude": "-94.6059101",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 816-753-3939",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-07e3-7403-ac7f-21ff8ecafa32.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-07e3-7403-ac7f-21ff8ecafa32",
        "storage_key": "property/6767906449167623/019ff6a1-07e3-7403-ac7f-21ff8ecafa32.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJu5DhjCzuwIcRQ2rCFQaF7S4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_c02adc38-be96-48f4-9768-73b7a1487ccb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Q39 - Midtown",
      "poi_type": "Restaurants",
      "poi_address": "1000 W 39th St, Kansas City, MO 64111, USA",
      "poi_short_description": "Hip, airy joint with beamed ceilings & exposed brick serving smoked BBQ & wood-fired meats.",
      "poi_long_description": "Hip, airy joint with beamed ceilings & exposed brick serving smoked BBQ & wood-fired meats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b66f-15af-751c-8a5f-b657feb1e6ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66f-15af-751c-8a5f-b657feb1e6ed",
        "storage_key": "property/6767906449167623/01a0b66f-15af-751c-8a5f-b657feb1e6ed.webp",
        "width": 1136,
        "height": 556
      },
      "poi_business_url": "https://q39kc.com/locations/kansas-city-bbq/?utm_source=Google&utm_medium=Maps&utm_campaign=GBP_midtown",
      "poi_directions_map_url": "https://maps.google.com/?cid=5504754235694060525&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "q39---midtown",
      "poi_latitude": "39.0573424",
      "poi_longitude": "-94.5982173",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-255-3753",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-07e3-7403-ac7f-21ff8ecafa32.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-07e3-7403-ac7f-21ff8ecafa32",
        "storage_key": "property/6767906449167623/019ff6a1-07e3-7403-ac7f-21ff8ecafa32.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ541xZ9HvwIcR7RNf2s_QZEw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_71c817b9-4eed-4167-b6c6-61b2e7d2452f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Fric & Frac",
      "poi_type": "Restaurants",
      "poi_address": "1700 W 39th St, Kansas City, MO 64111, USA",
      "poi_short_description": "Intimate, family-friendly neighborhood tavern serving burgers, sandwiches & beer.",
      "poi_long_description": "Intimate, family-friendly neighborhood tavern serving burgers, sandwiches & beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a3-ea31-746f-b2a1-2bf358428148.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-ea31-746f-b2a1-2bf358428148",
        "storage_key": "property/6767906449167623/019ff6a3-ea31-746f-b2a1-2bf358428148.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://fricandfrac.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8011214448822873983&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fric--frac",
      "poi_latitude": "39.057391",
      "poi_longitude": "-94.605096",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 816-753-6102",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-07e3-7403-ac7f-21ff8ecafa32.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-07e3-7403-ac7f-21ff8ecafa32",
        "storage_key": "property/6767906449167623/019ff6a1-07e3-7403-ac7f-21ff8ecafa32.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJX8D9lCzuwIcRf2-QkRiNLW8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_ac73db39-0659-44ca-be23-22513c09a5bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Tiki Taco",
      "poi_type": "Restaurants",
      "poi_address": "1710 W 39th St, Kansas City, MO 64111, USA",
      "poi_short_description": "Casual joint for tacos, burritos and other Mexican fare, plus beer and cocktails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a3-e44d-770a-97b4-af2168536b4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-e44d-770a-97b4-af2168536b4b",
        "storage_key": "property/6767906449167623/019ff6a3-e44d-770a-97b4-af2168536b4b.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://www.tikitaco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13656237836785296636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tiki-taco",
      "poi_latitude": "39.0573851",
      "poi_longitude": "-94.6055041",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 877-213-2408",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-07e3-7403-ac7f-21ff8ecafa32.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-07e3-7403-ac7f-21ff8ecafa32",
        "storage_key": "property/6767906449167623/019ff6a1-07e3-7403-ac7f-21ff8ecafa32.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJw5ewfezvwIcR_CTWbfWzhL0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "taco_restaurant"
    },
    {
      "id": "custom_345197e1-c930-4196-9e7b-c3b2c8a57054",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Friends Sushi & Bento Place",
      "poi_type": "Restaurants",
      "poi_address": "1808 W 39th St, Kansas City, MO 64111, USA",
      "poi_short_description": "Welcoming outfit offers a range of sushi & hot Japanese cooking, plus lunch specials.",
      "poi_long_description": "Welcoming outfit offers a range of sushi & hot Japanese cooking, plus lunch specials.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019fc993-428c-749e-9508-3fd2c8e57d80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-428c-749e-9508-3fd2c8e57d80",
        "storage_key": "property/6767906449167623/019fc993-428c-749e-9508-3fd2c8e57d80.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://friendssushi.menufy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8536375522138180246&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "friends-sushi--bento-place",
      "poi_latitude": "39.0574814",
      "poi_longitude": "-94.6066648",
      "poi_miles_from_property": "0.06",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 816-753-6666",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-07e3-7403-ac7f-21ff8ecafa32.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-07e3-7403-ac7f-21ff8ecafa32",
        "storage_key": "property/6767906449167623/019ff6a1-07e3-7403-ac7f-21ff8ecafa32.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4_0sYSzuwIcRlspiSk9Md3Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_0d75b70e-e683-4f32-8900-0e4581674c04",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Meshuggah Bagels",
      "poi_type": "Restaurants",
      "poi_address": "1208 W 39th St, Kansas City, MO 64111, USA",
      "poi_short_description": "New York style bagel shop offering a variety of flavors and schmears, plus breakfast, and lunch.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019fc993-4b72-753e-bfa1-75f013a7a799.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-4b72-753e-bfa1-75f013a7a799",
        "storage_key": "property/6767906449167623/019fc993-4b72-753e-bfa1-75f013a7a799.webp",
        "width": 1280,
        "height": 967
      },
      "poi_business_url": "http://www.meshuggahbagels.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13675545978663753829&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meshuggah-bagels",
      "poi_latitude": "39.0573253",
      "poi_longitude": "-94.6010041",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-330-6016",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-07e3-7403-ac7f-21ff8ecafa32.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-07e3-7403-ac7f-21ff8ecafa32",
        "storage_key": "property/6767906449167623/019ff6a1-07e3-7403-ac7f-21ff8ecafa32.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYXspoNPvwIcRZVjGh5xMyb0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bagel_shop"
    },
    {
      "id": "custom_83ead6ed-3d26-432b-b2d6-1dd134961b35",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Aladdin Cafe",
      "poi_type": "Restaurants",
      "poi_address": "3903 Wyoming St, Kansas City, MO 64111, USA",
      "poi_short_description": "Greek & Mediterranean cuisine amid casual quirky atmosphere with an outdoor hookah lounge in summer.",
      "poi_long_description": "Greek & Mediterranean cuisine amid casual quirky atmosphere with an outdoor hookah lounge in summer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a4-0056-735e-a349-bb389b2cf544.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-0056-735e-a349-bb389b2cf544",
        "storage_key": "property/6767906449167623/019ff6a4-0056-735e-a349-bb389b2cf544.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.aladdincafe.co/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4312542471863267736&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aladdin-cafe",
      "poi_latitude": "39.0570502",
      "poi_longitude": "-94.6034539",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 816-531-5982",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-07e3-7403-ac7f-21ff8ecafa32.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-07e3-7403-ac7f-21ff8ecafa32",
        "storage_key": "property/6767906449167623/019ff6a1-07e3-7403-ac7f-21ff8ecafa32.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ91hEM9PvwIcRmPExgoc62Ts",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_05f8857a-b56e-4b18-b859-148388235a5b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Miami Ice",
      "poi_type": "Restaurants",
      "poi_address": "1624 W 39th St, Kansas City, MO 64111, USA",
      "poi_short_description": "Longtime, family-run spot doling out shaved ice, frozen custard with mix-ins & other cold treats.",
      "poi_long_description": "Longtime, family-run spot doling out shaved ice, frozen custard with mix-ins & other cold treats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019fc994-7270-7671-baa3-37d361e48122.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-7270-7671-baa3-37d361e48122",
        "storage_key": "property/6767906449167623/019fc994-7270-7671-baa3-37d361e48122.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://www.facebook.com/miamiicekc",
      "poi_directions_map_url": "https://maps.google.com/?cid=12638733439214371619&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "miami-ice",
      "poi_latitude": "39.0573988",
      "poi_longitude": "-94.6048507",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-07de-7229-843d-ff5c6b09804a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-07de-7229-843d-ff5c6b09804a",
        "storage_key": "property/6767906449167623/019ff6a1-07de-7229-843d-ff5c6b09804a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJX0IHvyzuwIcRI0M5nxnNZa8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ice_cream_shop"
    },
    {
      "id": "custom_442b4f23-910e-4d4b-8f5c-5328ba29de7a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "KC Smoke Burger",
      "poi_type": "Restaurants",
      "poi_address": "1610 W 39th St, Kansas City, MO 64111, USA",
      "poi_short_description": "Casual restaurant with eclectic decor serving smoked burgers, plus cheesesteaks & hot dogs.",
      "poi_long_description": "Casual restaurant with eclectic decor serving smoked burgers, plus cheesesteaks & hot dogs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a3-f9ce-706f-9ce3-642212e73b80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-f9ce-706f-9ce3-642212e73b80",
        "storage_key": "property/6767906449167623/019ff6a3-f9ce-706f-9ce3-642212e73b80.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://kcsmokeburgers.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3581502734046957737&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kc-smoke-burger",
      "poi_latitude": "39.0575007",
      "poi_longitude": "-94.6043973",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 816-931-4455",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-07e3-7403-ac7f-21ff8ecafa32.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-07e3-7403-ac7f-21ff8ecafa32",
        "storage_key": "property/6767906449167623/019ff6a1-07e3-7403-ac7f-21ff8ecafa32.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJk8JHtyzuwIcRqZD10MINtDE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_915ddae7-8b0d-4c72-8778-2f72ea1214d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Pizza Tascio - 39th Street",
      "poi_type": "Restaurants",
      "poi_address": "1806 W 39th St, Kansas City, MO 64111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019fc993-1775-729c-b993-ded0253abc1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-1775-729c-b993-ded0253abc1d",
        "storage_key": "property/6767906449167623/019fc993-1775-729c-b993-ded0253abc1d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.pizzatascio.com/s/order?location=11ee703464fe1cb9a88cac1f6bbba828",
      "poi_directions_map_url": "https://maps.google.com/?cid=17345737171970328750&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pizza-tascio---39th-street",
      "poi_latitude": "39.0574753",
      "poi_longitude": "-94.6065663",
      "poi_miles_from_property": "0.06",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 816-476-1770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-07e3-7403-ac7f-21ff8ecafa32.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-07e3-7403-ac7f-21ff8ecafa32",
        "storage_key": "property/6767906449167623/019ff6a1-07e3-7403-ac7f-21ff8ecafa32.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvWoCMErvwIcRroiUZg5wuPA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_cbd4e770-2ac5-45ce-a074-cd5bad687236",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "OurHouseKC",
      "poi_type": "Restaurants",
      "poi_address": "1815 W 39th St, Kansas City, MO 64111, USA",
      "poi_short_description": "Casual, welcoming, music-themed eatery serving smoked meats and barbecue plates, such as brisket and pulled pork, alongside brunch offerings.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019fc994-450a-7593-9f68-5edec94e1141.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-450a-7593-9f68-5edec94e1141",
        "storage_key": "property/6767906449167623/019fc994-450a-7593-9f68-5edec94e1141.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://ourhousekc.com/?utm_source=gbpr&utm_medium=organic&utm_id=ifocus",
      "poi_directions_map_url": "https://maps.google.com/?cid=9573852984122984736&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ourhousekc",
      "poi_latitude": "39.0571948",
      "poi_longitude": "-94.6067563",
      "poi_miles_from_property": "0.05",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 816-442-8569",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-07e3-7403-ac7f-21ff8ecafa32.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-07e3-7403-ac7f-21ff8ecafa32",
        "storage_key": "property/6767906449167623/019ff6a1-07e3-7403-ac7f-21ff8ecafa32.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJyya0lU_vwIcRIMl2ipAo3YQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_fae43c59-3ad3-420e-93f2-819b0a76bbc0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Jazz A Louisiana Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "1823 W 39th St, Kansas City, MO 64111, USA",
      "poi_short_description": "Relaxed Cajun-Creole chain serving classic fare, including po' boys, gumbo & blackened catfish.",
      "poi_long_description": "Relaxed Cajun-Creole chain serving classic fare, including po' boys, gumbo & blackened catfish.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019fc993-14c1-72a9-9727-f1d9dbd47e10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-14c1-72a9-9727-f1d9dbd47e10",
        "storage_key": "property/6767906449167623/019fc993-14c1-72a9-9727-f1d9dbd47e10.webp",
        "width": 909,
        "height": 569
      },
      "poi_business_url": "http://www.jazzkitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12107188632765135493&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jazz-a-louisiana-kitchen",
      "poi_latitude": "39.0570647",
      "poi_longitude": "-94.6071229",
      "poi_miles_from_property": "0.04",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 816-531-5556",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-07e3-7403-ac7f-21ff8ecafa32.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-07e3-7403-ac7f-21ff8ecafa32",
        "storage_key": "property/6767906449167623/019ff6a1-07e3-7403-ac7f-21ff8ecafa32.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0RpVZizuwIcRhfqcNOpfBag",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cajun_restaurant"
    },
    {
      "id": "custom_287710c5-8e74-43af-8f0d-f8a87c3e7f7e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Rudy's Tenampa Taqueria",
      "poi_type": "Restaurants",
      "poi_address": "1611 Westport Rd, Kansas City, MO 64111, USA",
      "poi_short_description": "Longtime family-owned spot for traditional Mexican dishes & casual, comfortable atmosphere.",
      "poi_long_description": "Longtime family-owned spot for traditional Mexican dishes & casual, comfortable atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b671-62c4-761f-8c92-43da693d6131.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-62c4-761f-8c92-43da693d6131",
        "storage_key": "property/6767906449167623/01a0b671-62c4-761f-8c92-43da693d6131.webp",
        "width": 1280,
        "height": 765
      },
      "poi_business_url": "http://www.rudystenampa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7195718614452621146&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rudys-tenampa-taqueria",
      "poi_latitude": "39.050008",
      "poi_longitude": "-94.605064",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-931-9700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-07e3-7403-ac7f-21ff8ecafa32.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-07e3-7403-ac7f-21ff8ecafa32",
        "storage_key": "property/6767906449167623/019ff6a1-07e3-7403-ac7f-21ff8ecafa32.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZW7xFzPuwIcRWk8djvRT3GM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_6cfaa94f-f6cc-46d2-9b02-232d320c5ce6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Genghis Khan Mongolian Grill",
      "poi_type": "Restaurants",
      "poi_address": "3906 Bell St, Kansas City, MO 64111, USA",
      "poi_short_description": "Cozy, casual Mongolian eatery with both à la carte & all-you-can-eat buffet options.",
      "poi_long_description": "Cozy, casual Mongolian eatery with both à la carte & all-you-can-eat buffet options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019fc993-44e8-704d-be13-6a66fb4fd593.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-44e8-704d-be13-6a66fb4fd593",
        "storage_key": "property/6767906449167623/019fc993-44e8-704d-be13-6a66fb4fd593.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.gkbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5945895791245163409&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "genghis-khan-mongolian-grill",
      "poi_latitude": "39.0568719",
      "poi_longitude": "-94.6063197",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 816-753-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-07e3-7403-ac7f-21ff8ecafa32.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-07e3-7403-ac7f-21ff8ecafa32",
        "storage_key": "property/6767906449167623/019ff6a1-07e3-7403-ac7f-21ff8ecafa32.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqQ4n9SzuwIcRkXuoLLgQhFI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_restaurant"
    },
    {
      "id": "custom_a866445b-295f-4939-9c34-8e3304857b10",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Kari's on 39th",
      "poi_type": "Restaurants",
      "poi_address": "1715 W 39th St, Kansas City, MO 64111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a3-e62e-721a-a6f5-f0166aeb67bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-e62e-721a-a6f5-f0166aeb67bf",
        "storage_key": "property/6767906449167623/019ff6a3-e62e-721a-a6f5-f0166aeb67bf.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "http://karison39th.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1308790681576355665&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "karis-on-39th",
      "poi_latitude": "39.0571204",
      "poi_longitude": "-94.6057799",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 816-621-0210",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-07e3-7403-ac7f-21ff8ecafa32.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-07e3-7403-ac7f-21ff8ecafa32",
        "storage_key": "property/6767906449167623/019ff6a1-07e3-7403-ac7f-21ff8ecafa32.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbQ6FAfLvwIcRUTezzDDCKRI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_631210c5-a06a-46e6-9481-54caaae2c0c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Mr Z's In & Out",
      "poi_type": "Shopping & Retail",
      "poi_address": "1600 W 39th St, Kansas City, MO 64111, USA",
      "poi_short_description": "Quick-visit convenience store offering a range of items.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a4-33ed-765f-91cb-62ae4c2bff13.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-33ed-765f-91cb-62ae4c2bff13",
        "storage_key": "property/6767906449167623/019ff6a4-33ed-765f-91cb-62ae4c2bff13.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.facebook.com/pages/Mr-Zs-In-Out/147250861969627",
      "poi_directions_map_url": "https://maps.google.com/?cid=10322821531336826299&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mr-zs-in--out",
      "poi_latitude": "39.0573898",
      "poi_longitude": "-94.6039523",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 816-753-5156",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a4-a28a-700c-9fd5-9bd92af0a478.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-a28a-700c-9fd5-9bd92af0a478",
        "storage_key": "property/6767906449167623/019ff6a4-a28a-700c-9fd5-9bd92af0a478.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJDwaLtCzuwIcRu90Vd30HQo8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_212f8e6c-611d-4fa1-9bd8-e636dee5a4d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Fast Stop",
      "poi_type": "Shopping & Retail",
      "poi_address": "131 E 39th St, Kansas City, MO 64111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a4-0ffc-728b-996d-2b3ed976343b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-0ffc-728b-996d-2b3ed976343b",
        "storage_key": "property/6767906449167623/019ff6a4-0ffc-728b-996d-2b3ed976343b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11082767303206315198&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fast-stop",
      "poi_latitude": "39.0563309",
      "poi_longitude": "-94.5842063",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-931-9327",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a4-a28a-700c-9fd5-9bd92af0a478.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-a28a-700c-9fd5-9bd92af0a478",
        "storage_key": "property/6767906449167623/019ff6a4-a28a-700c-9fd5-9bd92af0a478.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJJxa7c93vwIcRviTtqyTmzZk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_6f8020db-f8c6-487e-b485-1fb75a3da22c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Cosentino's Sun Fresh Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "4001 Mill St, Kansas City, MO 64111, USA",
      "poi_short_description": "Supermarket offering produce, prepared foods, and organic products, plus a pharmacy, a florist, and a liquor store.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019fc993-8870-7678-bd2b-968269af4367.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-8870-7678-bd2b-968269af4367",
        "storage_key": "property/6767906449167623/019fc993-8870-7678-bd2b-968269af4367.webp",
        "width": 1280,
        "height": 679
      },
      "poi_business_url": "https://cosentinos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9583179988153697737&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cosentinos-sun-fresh-market",
      "poi_latitude": "39.054676",
      "poi_longitude": "-94.594949",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-931-1639",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-083d-745c-8ccb-4b7e774c9f77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-083d-745c-8ccb-4b7e774c9f77",
        "storage_key": "property/6767906449167623/019ff6a1-083d-745c-8ccb-4b7e774c9f77.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOcHUGdDvwIcRyYWI5GxL_oQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_ad283f3c-c42f-4901-9b30-8da379300429",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Midtown Market | Indian | Desi | Grocery Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "3967 Main St, Kansas City, MO 64111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6be-199f-739f-8764-c73bf31dcf2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6be-199f-739f-8764-c73bf31dcf2a",
        "storage_key": "property/6767906449167623/019ff6be-199f-739f-8764-c73bf31dcf2a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.kcmintmasala.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7644181150302927336&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midtown-market--indian--desi--grocery-store",
      "poi_latitude": "39.0545106",
      "poi_longitude": "-94.5853768",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-396-1629",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-083d-745c-8ccb-4b7e774c9f77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-083d-745c-8ccb-4b7e774c9f77",
        "storage_key": "property/6767906449167623/019ff6a1-083d-745c-8ccb-4b7e774c9f77.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlUlGM6DvwIcR6PmKbkGWFWo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_b6cd02eb-2e08-4b60-8ed1-af1225c2978d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "3830 Prospect Ave, Kansas City, MO 64128, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6be-14f5-7154-9a99-be39179b324e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6be-14f5-7154-9a99-be39179b324e",
        "storage_key": "property/6767906449167623/019ff6be-14f5-7154-9a99-be39179b324e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://info.aldi.us/stores/l/mo/kansas-city/3830-prospect-ave/f342",
      "poi_directions_map_url": "https://maps.google.com/?cid=8014088591275778421&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "39.056581",
      "poi_longitude": "-94.554169",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-083d-745c-8ccb-4b7e774c9f77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-083d-745c-8ccb-4b7e774c9f77",
        "storage_key": "property/6767906449167623/019ff6a1-083d-745c-8ccb-4b7e774c9f77.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDVJVDyA134cRdeGAAR3DN28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_4a913ff1-9209-4b1e-ac99-eb8000773dba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "3845 Broadway Blvd, Kansas City, MO 64111, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019fc993-8238-775e-86fe-d2d4f4f05051.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-8238-775e-86fe-d2d4f4f05051",
        "storage_key": "property/6767906449167623/019fc993-8238-775e-86fe-d2d4f4f05051.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-3845+broadway+blvd-kansas+city-mo-64111/id=5278",
      "poi_directions_map_url": "https://maps.google.com/?cid=15848482437788268161&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "39.05738789999999",
      "poi_longitude": "-94.5901947",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-561-7620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-077b-7221-8ccd-5832925f91c3",
        "storage_key": "property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVTrIudvvwIcRgfZi7c4e8ds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_c8a36ca4-ded5-4396-bd2e-31a2f7da38ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Whole foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "301 E 51st St, Kansas City, MO 64112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b671-6b65-719b-953f-9a79980db132.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-6b65-719b-953f-9a79980db132",
        "storage_key": "property/6767906449167623/01a0b671-6b65-719b-953f-9a79980db132.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/kansascity",
      "poi_directions_map_url": "https://maps.google.com/?cid=8698117794034062261&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "39.0344601",
      "poi_longitude": "-94.583645",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 816-708-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-083d-745c-8ccb-4b7e774c9f77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-083d-745c-8ccb-4b7e774c9f77",
        "storage_key": "property/6767906449167623/019ff6a1-083d-745c-8ccb-4b7e774c9f77.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT-FpdgDvwIcRtZPnjwzstXg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_dc3cbfff-06ef-494a-b401-bde6b9f8283a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Cosentino's Price Chopper",
      "poi_type": "Shopping & Retail",
      "poi_address": "6327 Brookside Plaza, Kansas City, MO 64113, USA",
      "poi_short_description": "Urban grocery store offering produce, meats and baked goods along with beer and wine.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a4-16ab-725b-900a-bae8167b22ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-16ab-725b-900a-bae8167b22ca",
        "storage_key": "property/6767906449167623/019ff6a4-16ab-725b-900a-bae8167b22ca.webp",
        "width": 1280,
        "height": 824
      },
      "poi_business_url": "https://www.mypricechopper.com/store-details?storeId=82",
      "poi_directions_map_url": "https://maps.google.com/?cid=5601713248782007001&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cosentinos-price-chopper",
      "poi_latitude": "39.01302250000001",
      "poi_longitude": "-94.5903738",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-523-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-083d-745c-8ccb-4b7e774c9f77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-083d-745c-8ccb-4b7e774c9f77",
        "storage_key": "property/6767906449167623/019ff6a1-083d-745c-8ccb-4b7e774c9f77.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXbd8NA7vwIcR2TpAR4VIvU0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_771b228f-9455-4a41-b91b-4f101d2bf0db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "8600 Ward Pkwy, Kansas City, MO 64114, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019fc98e-fdee-7723-9f61-9b07e00115a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98e-fdee-7723-9f61-9b07e00115a5",
        "storage_key": "property/6767906449167623/019fc98e-fdee-7723-9f61-9b07e00115a5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/mo/kansas-city/720/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=13718771023150469206&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "38.9713402",
      "poi_longitude": "-94.6064342",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 816-333-5322",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-083d-745c-8ccb-4b7e774c9f77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-083d-745c-8ccb-4b7e774c9f77",
        "storage_key": "property/6767906449167623/019ff6a1-083d-745c-8ccb-4b7e774c9f77.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJda3_VSbpwIcRVlDOdY_dYr4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_1d6faaf7-215c-46db-93fe-3262d3499e08",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Westport Montessori",
      "poi_type": "Education",
      "poi_address": "3930 Baltimore Ave, Kansas City, MO 64111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019fc994-3121-73bd-8686-b66f45603906.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-3121-73bd-8686-b66f45603906",
        "storage_key": "property/6767906449167623/019fc994-3121-73bd-8686-b66f45603906.webp",
        "width": 900,
        "height": 600
      },
      "poi_business_url": "https://westportmontessori.com/montessori-locations/westport-montessori/?y_source=1_MjAyMTc1Mjk3Ny03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12874677318715617879&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westport-montessori",
      "poi_latitude": "39.0553457",
      "poi_longitude": "-94.5878104",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-753-6633",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-082a-74ce-93b0-7f197befc21f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-082a-74ce-93b0-7f197befc21f",
        "storage_key": "property/6767906449167623/019ff6a1-082a-74ce-93b0-7f197befc21f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvdxvmNzvwIcRV7LS884KrLI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_a70089be-fa0e-45bf-9391-cb93a52deadf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Kansas City Art Institute",
      "poi_type": "Education",
      "poi_address": "4415 Warwick Blvd, Kansas City, MO 64111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019fc993-f36d-7378-bf49-39a6e2b87e9b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-f36d-7378-bf49-39a6e2b87e9b",
        "storage_key": "property/6767906449167623/019fc993-f36d-7378-bf49-39a6e2b87e9b.webp",
        "width": 705,
        "height": 670
      },
      "poi_business_url": "http://www.kcai.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3056374416396262313&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-art-institute",
      "poi_latitude": "39.0466734",
      "poi_longitude": "-94.5834059",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-472-4852",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-082a-74ce-93b0-7f197befc21f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-082a-74ce-93b0-7f197befc21f",
        "storage_key": "property/6767906449167623/019ff6a1-082a-74ce-93b0-7f197befc21f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJffVj1cHvwIcRqRvknVZsaio",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_b01800fc-31ac-49a1-9e17-5c66fee4e83c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "The Plaza Academy",
      "poi_type": "Education",
      "poi_address": "3930 Broadway Blvd, Kansas City, MO 64111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019fc994-4770-741a-8b75-5876be7562b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-4770-741a-8b75-5876be7562b8",
        "storage_key": "property/6767906449167623/019fc994-4770-741a-8b75-5876be7562b8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.plazaacademy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6124555163440923688&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-plaza-academy",
      "poi_latitude": "39.0554757",
      "poi_longitude": "-94.5910198",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-561-0770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-082a-74ce-93b0-7f197befc21f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-082a-74ce-93b0-7f197befc21f",
        "storage_key": "property/6767906449167623/019ff6a1-082a-74ce-93b0-7f197befc21f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJfYwchc_vwIcRKEQuzHjK_lQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_1670462d-7812-4175-8ad0-d79def082092",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "University of Missouri-Kansas City",
      "poi_type": "Education",
      "poi_address": "5000 Holmes St, Kansas City, MO 64110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019fc98f-073c-737f-8fd4-65172b7a1a63.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98f-073c-737f-8fd4-65172b7a1a63",
        "storage_key": "property/6767906449167623/019fc98f-073c-737f-8fd4-65172b7a1a63.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.umkc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10660093312754521544&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-missouri-kansas-city",
      "poi_latitude": "39.0333035",
      "poi_longitude": "-94.577545",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-235-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-082a-74ce-93b0-7f197befc21f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-082a-74ce-93b0-7f197befc21f",
        "storage_key": "property/6767906449167623/019ff6a1-082a-74ce-93b0-7f197befc21f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ856Hn5DvwIcRyBVAa2NC8JM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_ee52232f-988f-4844-92db-aa788f80af27",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "KU Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "3901 Rainbow Blvd, Kansas City, KS 66160, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019fc991-d288-752e-9b77-07566d018dd9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc991-d288-752e-9b77-07566d018dd9",
        "storage_key": "property/6767906449167623/019fc991-d288-752e-9b77-07566d018dd9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.kumc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9948285583475587924&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ku-medical-center",
      "poi_latitude": "39.0582747",
      "poi_longitude": "-94.6105991",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 913-588-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-0836-7779-aa4f-fb3b932df7ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-0836-7779-aa4f-fb3b932df7ac",
        "storage_key": "property/6767906449167623/019ff6a1-0836-7779-aa4f-fb3b932df7ac.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJdbsoKb3vwIcRVLszpwdpD4o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_d38cdbd6-d779-41a2-9ed9-92824d804c0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Rockhurst University",
      "poi_type": "Education",
      "poi_address": "1100 Rockhurst Rd, Kansas City, MO 64110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019fc98e-ed0d-71ce-9232-e5b3c9550e5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98e-ed0d-71ce-9232-e5b3c9550e5b",
        "storage_key": "property/6767906449167623/019fc98e-ed0d-71ce-9232-e5b3c9550e5b.webp",
        "width": 960,
        "height": 320
      },
      "poi_business_url": "https://www.rockhurst.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16644960823377639958&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rockhurst-university",
      "poi_latitude": "39.0303478",
      "poi_longitude": "-94.5710674",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 816-501-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-082a-74ce-93b0-7f197befc21f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-082a-74ce-93b0-7f197befc21f",
        "storage_key": "property/6767906449167623/019ff6a1-082a-74ce-93b0-7f197befc21f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJU6rD5oTvwIcRFrq3Ga7H_uY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_1a078442-036f-4ea1-aa55-e81ce15827dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "The Pembroke Hill School- Ward Parkway Campus",
      "poi_type": "Education",
      "poi_address": "5121 State Line Rd, Kansas City, MO 64112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a4-239d-7509-b50a-52d8962c1f81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-239d-7509-b50a-52d8962c1f81",
        "storage_key": "property/6767906449167623/019ff6a4-239d-7509-b50a-52d8962c1f81.webp",
        "width": 1024,
        "height": 300
      },
      "poi_business_url": "https://www.pembrokehill.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16355221575956153002&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-pembroke-hill-school--ward-parkway-campus",
      "poi_latitude": "39.0355217",
      "poi_longitude": "-94.6057468",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-936-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-082a-74ce-93b0-7f197befc21f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-082a-74ce-93b0-7f197befc21f",
        "storage_key": "property/6767906449167623/019ff6a1-082a-74ce-93b0-7f197befc21f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4eI1uE3uwIcRqsKroV5r-eI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_79a8313b-fbbf-47c7-ad6a-0a57e43e42d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Ewing Marion Kauffman School",
      "poi_type": "Education",
      "poi_address": "6401 The Paseo, Kansas City, MO 64131, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b671-6ca9-77ef-99aa-090cb269b1f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-6ca9-77ef-99aa-090cb269b1f3",
        "storage_key": "property/6767906449167623/01a0b671-6ca9-77ef-99aa-090cb269b1f3.webp",
        "width": 900,
        "height": 550
      },
      "poi_business_url": "http://www.kauffmanschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6918407502411794196&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ewing-marion-kauffman-school",
      "poi_latitude": "39.0112503",
      "poi_longitude": "-94.5673961",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 816-268-5660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-082a-74ce-93b0-7f197befc21f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-082a-74ce-93b0-7f197befc21f",
        "storage_key": "property/6767906449167623/019ff6a1-082a-74ce-93b0-7f197befc21f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTzj1ncXvwIcRFAen2PceA2A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_510f7d26-42bc-40d1-aa2a-8109fdb5e763",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Primitivo Garcia Elementary School",
      "poi_type": "Education",
      "poi_address": "1000 W 17 St, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b671-6c9c-7248-8e12-fa698ca7804e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-6c9c-7248-8e12-fa698ca7804e",
        "storage_key": "property/6767906449167623/01a0b671-6c9c-7248-8e12-fa698ca7804e.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://primitivogarcia.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10435885958455630198&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primitivo-garcia-elementary-school",
      "poi_latitude": "39.0942702",
      "poi_longitude": "-94.595658",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-418-8725",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-082a-74ce-93b0-7f197befc21f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-082a-74ce-93b0-7f197befc21f",
        "storage_key": "property/6767906449167623/019ff6a1-082a-74ce-93b0-7f197befc21f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGVAkzU_wwIcRdhk8zvy205A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_ddb197f2-e645-4fbf-a385-4289e4e5c732",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Primrose School of Ward Parkway",
      "poi_type": "Education",
      "poi_address": "1309 Meadow Lake Pkwy, Kansas City, MO 64114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b671-6ca9-77ef-99aa-0587da1a7d46.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-6ca9-77ef-99aa-0587da1a7d46",
        "storage_key": "property/6767906449167623/01a0b671-6ca9-77ef-99aa-0587da1a7d46.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://www.primroseschools.com/schools/ward-parkway/?utm_source=gbp&utm_medium=maplistings",
      "poi_directions_map_url": "https://maps.google.com/?cid=4167466647962959099&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primrose-school-of-ward-parkway",
      "poi_latitude": "38.9888811",
      "poi_longitude": "-94.6068285",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 816-822-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-082a-74ce-93b0-7f197befc21f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-082a-74ce-93b0-7f197befc21f",
        "storage_key": "property/6767906449167623/019ff6a1-082a-74ce-93b0-7f197befc21f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJiRWgafvvwIcR-7weDdbQ1Tk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_7437acec-2f8a-4d6d-b6c5-a09edc4e9800",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "The Nelson-Atkins Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "4525 Oak St, Kansas City, MO 64111, USA",
      "poi_short_description": "Art collection spanning 5,000 years in neoclassical & modern galleries, plus a sculpture garden.",
      "poi_long_description": "Art collection spanning 5,000 years in neoclassical & modern galleries, plus a sculpture garden.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019fc994-73f3-77ae-aa2a-9fa1d8c59939.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-73f3-77ae-aa2a-9fa1d8c59939",
        "storage_key": "property/6767906449167623/019fc994-73f3-77ae-aa2a-9fa1d8c59939.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nelson-atkins.org/?utm_source=gmb&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=3122843275976164549&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-nelson-atkins-museum-of-art",
      "poi_latitude": "39.0449506",
      "poi_longitude": "-94.5809284",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-751-1278",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-07db-7499-ac16-9cdf94e90386.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-07db-7499-ac16-9cdf94e90386",
        "storage_key": "property/6767906449167623/019ff6a1-07db-7499-ac16-9cdf94e90386.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJRSCf3ervwIcRxcTG-WmRVis",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_570a7dac-0f66-4c11-9d11-345c10acc35d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Kemper Museum of Contemporary Art",
      "poi_type": "Entertainment",
      "poi_address": "4420 Warwick Blvd, Kansas City, MO 64111, USA",
      "poi_short_description": "Modest museum housing a permanent collection & special exhibitions of challenging contemporary art.",
      "poi_long_description": "Modest museum housing a permanent collection & special exhibitions of challenging contemporary art.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019fc994-7255-708a-b4f3-75afaca89e82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-7255-708a-b4f3-75afaca89e82",
        "storage_key": "property/6767906449167623/019fc994-7255-708a-b4f3-75afaca89e82.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kemperart.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4417124555838519064&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kemper-museum-of-contemporary-art",
      "poi_latitude": "39.04643",
      "poi_longitude": "-94.5851292",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-753-5784",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-07db-7499-ac16-9cdf94e90386.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-07db-7499-ac16-9cdf94e90386",
        "storage_key": "property/6767906449167623/019ff6a1-07db-7499-ac16-9cdf94e90386.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJjz4brcHvwIcRGPdob2HHTD0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_5c046e98-3195-4c0e-8123-771c4cfebd45",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Country Club Plaza",
      "poi_type": "Shopping & Retail",
      "poi_address": "4706 Broadway Blvd, Kansas City, MO 64112, USA",
      "poi_short_description": "Sprawling shopping area made up of Moorish-themed buildings housing stores & restaurants.",
      "poi_long_description": "Sprawling shopping area made up of Moorish-themed buildings housing stores & restaurants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019fc994-bdd9-74bf-9879-b11f95bedae2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-bdd9-74bf-9879-b11f95bedae2",
        "storage_key": "property/6767906449167623/019fc994-bdd9-74bf-9879-b11f95bedae2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://countryclubplaza.com/?utm_source=GoogleMyBusiness&utm_medium=Organic&utm_campaign=GMB",
      "poi_directions_map_url": "https://maps.google.com/?cid=12339093817016807577&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "country-club-plaza",
      "poi_latitude": "39.0419692",
      "poi_longitude": "-94.5926089",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-753-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-07de-7229-843d-ff5c6b09804a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-07de-7229-843d-ff5c6b09804a",
        "storage_key": "property/6767906449167623/019ff6a1-07de-7229-843d-ff5c6b09804a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJr4r_377vwIcRmXCBhXNEPas",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_c0919343-9ed3-4b30-ac66-162ca1c78626",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Uptown Theater KC",
      "poi_type": "Entertainment",
      "poi_address": "3700 Broadway Blvd, Kansas City, MO 64111, USA",
      "poi_short_description": "Classic 1920s film & performing-arts venue, now renovated & hosting concerts & other productions.",
      "poi_long_description": "Classic 1920s film & performing-arts venue, now renovated & hosting concerts & other productions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a4-284f-77dc-bf47-e856fcaace47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-284f-77dc-bf47-e856fcaace47",
        "storage_key": "property/6767906449167623/019ff6a4-284f-77dc-bf47-e856fcaace47.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.uptowntheater.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=846736320001238433&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uptown-theater-kc",
      "poi_latitude": "39.0611606",
      "poi_longitude": "-94.5907281",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-753-8665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-077b-7221-8ccd-5832925f91c3",
        "storage_key": "property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm94AB9nvwIcRoWUYZDI2wAs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wedding_venue"
    },
    {
      "id": "custom_6e4b02a7-a109-47ed-92da-faa7ad17e476",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Loose Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5200 Wornall Rd, Kansas City, MO 64112, USA",
      "poi_short_description": "Site of a Civil War battle, this 75-acre green space features a pond, tennis courts & a rose garden.",
      "poi_long_description": "Site of a Civil War battle, this 75-acre green space features a pond, tennis courts & a rose garden.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019fc994-61f2-7102-8a9e-481ece3af794.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-61f2-7102-8a9e-481ece3af794",
        "storage_key": "property/6767906449167623/019fc994-61f2-7102-8a9e-481ece3af794.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://kcparks.org/park/loose-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11009609457171665569&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "loose-park",
      "poi_latitude": "39.0313445",
      "poi_longitude": "-94.5944237",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-513-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-0783-7607-a5fc-663d90f0fc5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-0783-7607-a5fc-663d90f0fc5e",
        "storage_key": "property/6767906449167623/019ff6a1-0783-7607-a5fc-663d90f0fc5e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJUf-8Na_vwIcRoZJ_Snj9yZg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_b23f8a16-7900-4097-be7c-a71dc5ea1b0d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Kauffman Center for the Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "1601 Broadway Blvd, Kansas City, MO 64108, USA",
      "poi_short_description": "2 performance halls joined together under a glass dome, hosting music, opera, theater & dance.",
      "poi_long_description": "2 performance halls joined together under a glass dome, hosting music, opera, theater & dance.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019fc995-64f6-7496-b1d3-0daa1a711625.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-64f6-7496-b1d3-0daa1a711625",
        "storage_key": "property/6767906449167623/019fc995-64f6-7496-b1d3-0daa1a711625.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kauffmancenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6371724031435486048&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kauffman-center-for-the-performing-arts",
      "poi_latitude": "39.0941068",
      "poi_longitude": "-94.5876247",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-994-7222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-077b-7221-8ccd-5832925f91c3",
        "storage_key": "property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ99d4bkPwwIcRYDOIbD_pbFg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_ba570f8c-e1b2-4ad4-9eb9-32051b212f93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "National WWI Museum and Memorial",
      "poi_type": "Entertainment",
      "poi_address": "2 Memorial Dr, Kansas City, MO 64108, USA",
      "poi_short_description": "The nation's only public museum dedicated to WWI, with a large collection of photos, weapons & more.",
      "poi_long_description": "The nation's only public museum dedicated to WWI, with a large collection of photos, weapons & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019fc994-7a30-741b-b81e-fdce91d2e04e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-7a30-741b-b81e-fdce91d2e04e",
        "storage_key": "property/6767906449167623/019fc994-7a30-741b-b81e-fdce91d2e04e.webp",
        "width": 1280,
        "height": 1071
      },
      "poi_business_url": "https://www.theworldwar.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10469991631701161311&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "national-wwi-museum-and-memorial",
      "poi_latitude": "39.080663",
      "poi_longitude": "-94.5860835",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-888-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-07db-7499-ac16-9cdf94e90386.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-07db-7499-ac16-9cdf94e90386",
        "storage_key": "property/6767906449167623/019ff6a1-07db-7499-ac16-9cdf94e90386.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJpzAyJjzwwIcRXzXcqOrhTJE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_63928d5b-4810-45d6-b7aa-adbed9b1e2de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "recordBar",
      "poi_type": "Restaurants",
      "poi_address": "1520 Grand Blvd, Kansas City, MO 64108, USA",
      "poi_short_description": "Popular live-music joint with frequent all-ages shows & upscale-casual American grub.",
      "poi_long_description": "Popular live-music joint with frequent all-ages shows & upscale-casual American grub.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019fc994-d857-753f-b6e8-2bd6eacad2c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-d857-753f-b6e8-2bd6eacad2c1",
        "storage_key": "property/6767906449167623/019fc994-d857-753f-b6e8-2bd6eacad2c1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.therecordbar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15820400051945726622&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "recordbar",
      "poi_latitude": "39.0950003",
      "poi_longitude": "-94.5813388",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-766-2527",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a4-a27e-71ea-b84d-5f764d636794.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-a27e-71ea-b84d-5f764d636794",
        "storage_key": "property/6767906449167623/019ff6a4-a27e-71ea-b84d-5f764d636794.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfXSkMczvwIcRnuLL9AZajds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_49628662-15b4-418d-9e7b-997a9475f233",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Knuckleheads",
      "poi_type": "Entertainment",
      "poi_address": "2715 Rochester Ave, Kansas City, MO 64120, USA",
      "poi_short_description": "Live music, from rock to Elvis tributes to gospel, plus burgers & beer in biker-bar digs.",
      "poi_long_description": "Live music, from rock to Elvis tributes to gospel, plus burgers & beer in biker-bar digs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019fc994-8c87-75e3-9bda-9f0a8dc6f877.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-8c87-75e3-9bda-9f0a8dc6f877",
        "storage_key": "property/6767906449167623/019fc994-8c87-75e3-9bda-9f0a8dc6f877.webp",
        "width": 990,
        "height": 660
      },
      "poi_business_url": "http://www.knuckleheadskc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17711282734500576976&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "knuckleheads",
      "poi_latitude": "39.12054",
      "poi_longitude": "-94.5486505",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 816-483-1456",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-077b-7221-8ccd-5832925f91c3",
        "storage_key": "property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK0JG4m76wIcR0H5qAs8dy_U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_b51229ef-2178-49ab-871b-f9b66d6de05e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Boulevard Brewing Company",
      "poi_type": "Restaurants",
      "poi_address": "2501 Southwest Blvd, Kansas City, MO 64108, USA",
      "poi_short_description": "Sprawling, established local brewery featuring tours, free beer samples & other offerings.",
      "poi_long_description": "Sprawling, established local brewery featuring tours, free beer samples & other offerings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019fc994-90ce-748a-98f7-8f5013853787.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-90ce-748a-98f7-8f5013853787",
        "storage_key": "property/6767906449167623/019fc994-90ce-748a-98f7-8f5013853787.webp",
        "width": 851,
        "height": 315
      },
      "poi_business_url": "http://boulevard.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8520323881876952353&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boulevard-brewing-company",
      "poi_latitude": "39.082097",
      "poi_longitude": "-94.596736",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-474-7095",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-077b-7221-8ccd-5832925f91c3",
        "storage_key": "property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwzrz9zbwwIcRIZWNjm1FPnY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_3179b6ba-a87e-4f23-98f6-6e674e57b789",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Saint Luke's Hospital of Kansas City",
      "poi_type": "Health and Wellness",
      "poi_address": "4401 Wornall Rd, Kansas City, MO 64111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019fc995-6b41-7671-9e12-39f3a82901a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-6b41-7671-9e12-39f3a82901a8",
        "storage_key": "property/6767906449167623/019fc995-6b41-7671-9e12-39f3a82901a8.webp",
        "width": 1280,
        "height": 937
      },
      "poi_business_url": "http://www.saintlukeskc.org/locations/saint-lukes-hospital-kansas-city?utm_source=yext&utm_medium=local_listing&utm_campaign=yext_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=4012580085298393479&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-lukes-hospital-of-kansas-city",
      "poi_latitude": "39.0460972",
      "poi_longitude": "-94.58992940000002",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-932-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-0836-7779-aa4f-fb3b932df7ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-0836-7779-aa4f-fb3b932df7ac",
        "storage_key": "property/6767906449167623/019ff6a1-0836-7779-aa4f-fb3b932df7ac.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJJembMcTvwIcRh3EE-VOMrzc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_d31b8691-2653-4d9b-a6a6-c9a4d7ff714f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Research Medical Center ER of Brookside",
      "poi_type": "Health and Wellness",
      "poi_address": "6601 Rockhill Rd, Kansas City, MO 64131, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6be-1fea-74ae-9a7e-4ec9f802cf2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6be-1fea-74ae-9a7e-4ec9f802cf2b",
        "storage_key": "property/6767906449167623/019ff6be-1fea-74ae-9a7e-4ec9f802cf2b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hcamidwest.com/locations/research-medical-center-brookside-campus?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=4540928133743379137&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "research-medical-center-er-of-brookside",
      "poi_latitude": "39.0075704",
      "poi_longitude": "-94.5775679",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 816-276-7380",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-077b-7221-8ccd-5832925f91c3",
        "storage_key": "property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdf4TUWnvwIcRwQJaKhSeBD8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_05ad38ea-b89d-49c3-848c-1fcdc9aef734",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "CareNow Urgent Care - State Line Road",
      "poi_type": "Health and Wellness",
      "poi_address": "8951 State Line Rd, Kansas City, MO 64114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019fc994-ac9c-7440-be4e-d592f7b15052.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-ac9c-7440-be4e-d592f7b15052",
        "storage_key": "property/6767906449167623/019fc994-ac9c-7440-be4e-d592f7b15052.webp",
        "width": 616,
        "height": 346
      },
      "poi_business_url": "https://www.carenow.com/locations/kansas-city/state-line-road?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=3516147410637542177&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carenow-urgent-care---state-line-road",
      "poi_latitude": "38.9666938",
      "poi_longitude": "-94.6078338",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 816-443-0089",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-077b-7221-8ccd-5832925f91c3",
        "storage_key": "property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6Xzm7WrpwIcRIdP1zHDdyzA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_3d32e63c-5de7-48b7-9a0e-923a9f9b3de1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Ortho Urgent Care at KCOI",
      "poi_type": "Health and Wellness",
      "poi_address": "3651 College Blvd Suite 200 Entrance B, Leawood, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b671-718a-73ad-a1d5-54661c8349d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-718a-73ad-a1d5-54661c8349d8",
        "storage_key": "property/6767906449167623/01a0b671-718a-73ad-a1d5-54661c8349d8.webp",
        "width": 1280,
        "height": 873
      },
      "poi_business_url": "https://www.kcoi.com/orthopedic-care/urgent-care/?utm_source=google&utm_medium=organic&utm_campaign=urgentcare&utm_content=localgmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=12781274114409168368&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ortho-urgent-care-at-kcoi",
      "poi_latitude": "38.9267283",
      "poi_longitude": "-94.6281311",
      "poi_miles_from_property": "9.7",
      "poi_walking_minutes": "3 hours 36 mins",
      "poi_biking_minutes": "1 hour 23 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 913-319-7633",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-077b-7221-8ccd-5832925f91c3",
        "storage_key": "property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhaNCaJfpwIcR8P1AxhY1YLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_b9923abc-cf60-4934-a7a0-20fb2c3beeca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "3845 Broadway Blvd, Kansas City, MO 64111, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6be-2375-7624-898d-5a82e002d87c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6be-2375-7624-898d-5a82e002d87c",
        "storage_key": "property/6767906449167623/019ff6be-2375-7624-898d-5a82e002d87c.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-3845+broadway+blvd-kansas+city-mo-64111/id=5278",
      "poi_directions_map_url": "https://maps.google.com/?cid=4118661774572450347&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "39.0573811",
      "poi_longitude": "-94.5901655",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-561-7620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6be-5207-77b9-aa80-13b2d0623062.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6be-5207-77b9-aa80-13b2d0623062",
        "storage_key": "property/6767906449167623/019ff6be-5207-77b9-aa80-13b2d0623062.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk9gUutvvwIcRK_Je9w9tKDk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_1ccaef68-1ed2-4640-879b-dd0cf8fb6532",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "The Foundation Westport 24hr Gym",
      "poi_type": "Health and Wellness",
      "poi_address": "3800 Summit St, Kansas City, MO 64111, USA",
      "poi_short_description": "Three-level gym with 24/7 access and modern equipment that's divided by workout style.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b671-7663-73ce-a355-72529edea1fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-7663-73ce-a355-72529edea1fb",
        "storage_key": "property/6767906449167623/01a0b671-7663-73ce-a355-72529edea1fb.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "http://tfgyms.com/westport",
      "poi_directions_map_url": "https://maps.google.com/?cid=4318151019755605013&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-foundation-westport-24hr-gym",
      "poi_latitude": "39.0579215",
      "poi_longitude": "-94.5958745",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-702-1010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-077b-7221-8ccd-5832925f91c3",
        "storage_key": "property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS2hMELbvwIcRFQwGU3kn7Ts",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e963621f-caab-4b0f-b9c3-fb0002ddeb2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Bodyfit KC",
      "poi_type": "Health and Wellness",
      "poi_address": "3838 Main St, Kansas City, MO 64111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b671-7207-707e-8840-b585612c40fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-7207-707e-8840-b585612c40fc",
        "storage_key": "property/6767906449167623/01a0b671-7207-707e-8840-b585612c40fc.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "http://www.bodyfitkcmo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12766824566632083470&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bodyfit-kc",
      "poi_latitude": "39.0569413",
      "poi_longitude": "-94.5862927",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-834-9430",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-077b-7221-8ccd-5832925f91c3",
        "storage_key": "property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1TxlWdzvwIcRDvDVQ03fLLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_48274dc8-c4e5-45b7-a021-43778a3e3246",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Work Ethic KC",
      "poi_type": "Health and Wellness",
      "poi_address": "1306 W 39th St, Kansas City, MO 64111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b671-7212-72fa-9bb3-24bf36edbcb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-7212-72fa-9bb3-24bf36edbcb6",
        "storage_key": "property/6767906449167623/01a0b671-7212-72fa-9bb3-24bf36edbcb6.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://www.workethiccrossfit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11351398905854430056&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "work-ethic-kc",
      "poi_latitude": "39.0574158",
      "poi_longitude": "-94.6017999",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-307-6772",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-077b-7221-8ccd-5832925f91c3",
        "storage_key": "property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf_IXqEDvwIcRaAs2nylFiJ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_49ae4755-38c3-4193-93d1-f114aa98e59d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "BODYBAR Pilates - Kansas City",
      "poi_type": "Health and Wellness",
      "poi_address": "3660 Broadway Blvd, Kansas City, MO 64111, USA",
      "poi_short_description": "Pilates studio offering 40- to 50-minute Reformer classes for all fitness levels in a supportive environment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b671-7781-7636-8fd3-1dd78f172c8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-7781-7636-8fd3-1dd78f172c8e",
        "storage_key": "property/6767906449167623/01a0b671-7781-7636-8fd3-1dd78f172c8e.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://bodybarpilates.com/studios/kansas-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16335308916140983171&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bodybar-pilates---kansas-city",
      "poi_latitude": "39.0619697",
      "poi_longitude": "-94.591243",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-355-4774",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-082a-74ce-93b0-7f197befc21f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-082a-74ce-93b0-7f197befc21f",
        "storage_key": "property/6767906449167623/019ff6a1-082a-74ce-93b0-7f197befc21f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7alwDDHvwIcRg8PaOumssuI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_17625657-8fc5-4433-9603-0fde13efbe85",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Roanoke Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1209 Valentine Rd, Kansas City, MO 64111, USA",
      "poi_short_description": "Pleasant city park dotted with basketball courts, baseball fields and volleyball courts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b671-77db-7525-8e5a-bf3f14ee0ce4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-77db-7525-8e5a-bf3f14ee0ce4",
        "storage_key": "property/6767906449167623/01a0b671-77db-7525-8e5a-bf3f14ee0ce4.webp",
        "width": 1280,
        "height": 844
      },
      "poi_business_url": "https://www.roanokeparkkc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15292107770354465273&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "roanoke-park",
      "poi_latitude": "39.0604817",
      "poi_longitude": "-94.6003493",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-830-1791",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-0783-7607-a5fc-663d90f0fc5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-0783-7607-a5fc-663d90f0fc5e",
        "storage_key": "property/6767906449167623/019ff6a1-0783-7607-a5fc-663d90f0fc5e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJtWygGnTvwIcR-fn3_v56ONQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_3d782be1-51c4-42b3-939f-4325d8f9c98f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Park 39",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "300 E 39th St, Kansas City, MO 64111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b671-77ea-77db-b7e5-7868984c7243.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-77ea-77db-b7e5-7868984c7243",
        "storage_key": "property/6767906449167623/01a0b671-77ea-77db-b7e5-7868984c7243.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://park39.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3948149033312187778&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "park-39",
      "poi_latitude": "39.0568275",
      "poi_longitude": "-94.5822324",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-281-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-077b-7221-8ccd-5832925f91c3",
        "storage_key": "property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvea3EBbvwIcRgvXfqqCkyjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_97b8a223-b9d8-4e61-9276-e570172b7c0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Gillham Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3915 Gillham Rd, Kansas City, MO 64110, USA",
      "poi_short_description": "Kid-friendly park featuring playgrounds and a splash pad.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019fc994-efd2-714f-a9b9-4268e40e4fb9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-efd2-714f-a9b9-4268e40e4fb9",
        "storage_key": "property/6767906449167623/019fc994-efd2-714f-a9b9-4268e40e4fb9.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "http://kcparks.org/park/gillham-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4125589893627255631&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gillham-park",
      "poi_latitude": "39.0539932",
      "poi_longitude": "-94.5788865",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-513-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-0783-7607-a5fc-663d90f0fc5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-0783-7607-a5fc-663d90f0fc5e",
        "storage_key": "property/6767906449167623/019ff6a1-0783-7607-a5fc-663d90f0fc5e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJt6GFpujvwIcRTxuYYiYKQTk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_5f97363b-dbb8-4b85-ac26-4270616568ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Southmoreland Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4600 Oak St, Kansas City, MO 64111, USA",
      "poi_short_description": "Lush, shady spot featuring a playground, serene picnic area and an annual Shakespeare festival.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6be-2845-7212-9f85-4d931f23e7b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6be-2845-7212-9f85-4d931f23e7b3",
        "storage_key": "property/6767906449167623/019ff6be-2845-7212-9f85-4d931f23e7b3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://kcparks.org/park/southmoreland-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12812875925662899750&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southmoreland-park",
      "poi_latitude": "39.04383199999999",
      "poi_longitude": "-94.582651",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-513-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-0783-7607-a5fc-663d90f0fc5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-0783-7607-a5fc-663d90f0fc5e",
        "storage_key": "property/6767906449167623/019ff6a1-0783-7607-a5fc-663d90f0fc5e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJC1VAU5XvwIcRJp5K1MR60LE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_fd0f267b-750e-488c-b9f0-46e65d9a18c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Frank A. Theis Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4701 Oak St, Kansas City, MO 64110, USA",
      "poi_short_description": "Waterside park for recreation and events, plus a water-lantern festival.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a4-64da-7091-9cf2-0514106e9572.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-64da-7091-9cf2-0514106e9572",
        "storage_key": "property/6767906449167623/019ff6a4-64da-7091-9cf2-0514106e9572.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://kcparks.org/places/theis-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3941501393525599333&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frank-a-theis-park",
      "poi_latitude": "39.04099799999999",
      "poi_longitude": "-94.581027",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-0783-7607-a5fc-663d90f0fc5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-0783-7607-a5fc-663d90f0fc5e",
        "storage_key": "property/6767906449167623/019ff6a1-0783-7607-a5fc-663d90f0fc5e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkehMS5TvwIcRZezMaqIGszY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_d03f6c14-1141-4fbd-a9b3-745731a975d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Mill Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "W 43rd St &, Broadway Blvd, Kansas City, MO 64111, USA",
      "poi_short_description": "Relaxed outdoor spot featuring a circular walking track and a fountain, plus an array of workout equipment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6be-293c-76be-a448-bfa0c322ba84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6be-293c-76be-a448-bfa0c322ba84",
        "storage_key": "property/6767906449167623/019ff6be-293c-76be-a448-bfa0c322ba84.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://kcparks.org/places/mill-creek-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=488052792635368784&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mill-creek-park",
      "poi_latitude": "39.0460414",
      "poi_longitude": "-94.5883526",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-513-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-0783-7607-a5fc-663d90f0fc5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-0783-7607-a5fc-663d90f0fc5e",
        "storage_key": "property/6767906449167623/019ff6a1-0783-7607-a5fc-663d90f0fc5e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2_VoTU3vwIcRUCWr2G3pxQY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b6f16842-bc20-4539-90e0-004ce85f4ecb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Brush Creek Greenway Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4084-4200 Blue Pkwy, Kansas City, MO 64130, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019fc995-06df-7163-9fc6-a6d46ed35344.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-06df-7163-9fc6-a6d46ed35344",
        "storage_key": "property/6767906449167623/019fc995-06df-7163-9fc6-a6d46ed35344.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://kcparks.org/places/brush-creek-greenway/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16139355184988050431&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brush-creek-greenway-park",
      "poi_latitude": "39.0365371",
      "poi_longitude": "-94.537776",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 816-513-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-0783-7607-a5fc-663d90f0fc5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-0783-7607-a5fc-663d90f0fc5e",
        "storage_key": "property/6767906449167623/019ff6a1-0783-7607-a5fc-663d90f0fc5e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJi3VNPhLlwIcR_1MS4QeC-t8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_cbec45c9-2aef-4b0a-8728-21146b0c351d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "RideKC Streetcar",
      "poi_type": "Transportation & Transit",
      "poi_address": "Kansas City, MO 64106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019fc995-1225-76c9-9c42-6dd500972f37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-1225-76c9-9c42-6dd500972f37",
        "storage_key": "property/6767906449167623/019fc995-1225-76c9-9c42-6dd500972f37.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "http://kcstreetcar.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14607043082411620649&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ridekc-streetcar",
      "poi_latitude": "39.1084242",
      "poi_longitude": "-94.582015",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 816-627-2527",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-077b-7221-8ccd-5832925f91c3",
        "storage_key": "property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ95W1BQDxwIcRKbn4wUqktso",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_79787458-6558-4749-bca1-d1ac1416c0a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "KC Streetcar Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "41 Emanuel Cleaver II Blvd., Kansas City, MO 64112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12515265169659030799&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kc-streetcar-park-and-ride",
      "poi_latitude": "39.0413735",
      "poi_longitude": "-94.5860303",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-077b-7221-8ccd-5832925f91c3",
        "storage_key": "property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1bZqHgDvwIcRD21Y81wnr60",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_9cc4d60a-4465-48a3-a046-15191c8b9734",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Plaza Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Brookside Blvd, Kansas City, MO 64112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a4-5aaa-7168-8745-bdfcd1d5810c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-5aaa-7168-8745-bdfcd1d5810c",
        "storage_key": "property/6767906449167623/019ff6a4-5aaa-7168-8745-bdfcd1d5810c.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16027054283908015915&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "plaza-transit-center",
      "poi_latitude": "39.0410459",
      "poi_longitude": "-94.5858921",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-077b-7221-8ccd-5832925f91c3",
        "storage_key": "property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJQvbcADvwIcRK2c9zPSIa94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_depot"
    },
    {
      "id": "custom_48a1658d-4f05-486f-b2cb-bbe3c8adcc61",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "RideKC - 39th St & Troost Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "3829 Troost Ave, Kansas City, MO 64109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://ridekc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7289192013737135469&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ridekc---39th-st--troost-transit-center",
      "poi_latitude": "39.0563082",
      "poi_longitude": "-94.5718268",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-842-9070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-077b-7221-8ccd-5832925f91c3",
        "storage_key": "property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhUypIaHvwIcRbY1qRoRpKGU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_13a1bf8b-85ff-4c24-a497-721f120892ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "39th & Rainbow",
      "poi_type": "Transportation & Transit",
      "poi_address": "Kansas City, KS 66103, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3110313768868686357&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "39th--rainbow",
      "poi_latitude": "39.05718299999999",
      "poi_longitude": "-94.610579",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a4-a274-7272-b1cd-888912699b55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-a274-7272-b1cd-888912699b55",
        "storage_key": "property/6767906449167623/019ff6a4-a274-7272-b1cd-888912699b55.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJo4fHwy7uwIcRFapsxeQNKis",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_b1063802-ce24-4d92-ac51-57414410b4fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Kansas City",
      "poi_type": "Transportation & Transit",
      "poi_address": "30 W Pershing Rd Union Station, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019fc995-d00f-7361-a72e-b2f95e0a9692.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-d00f-7361-a72e-b2f95e0a9692",
        "storage_key": "property/6767906449167623/019fc995-d00f-7361-a72e-b2f95e0a9692.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=KCY",
      "poi_directions_map_url": "https://maps.google.com/?cid=3787247529242741214&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city",
      "poi_latitude": "39.0847966",
      "poi_longitude": "-94.5853578",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-0b04-709a-bcc9-698350923466.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-0b04-709a-bcc9-698350923466",
        "storage_key": "property/6767906449167623/019ff6a1-0b04-709a-bcc9-698350923466.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJxbu2nD_wwIcR3kn96I8BjzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_74f865ea-cfa3-4745-b6aa-c974bb660688",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Kansas City International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Kansas City Blvd, Kansas City, MO 64153, USA",
      "poi_short_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_long_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019fc995-222e-71ae-88b8-82167cc84f2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-222e-71ae-88b8-82167cc84f2d",
        "storage_key": "property/6767906449167623/019fc995-222e-71ae-88b8-82167cc84f2d.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.flykc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14109162014977743520&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-international-airport",
      "poi_latitude": "39.3013901",
      "poi_longitude": "-94.7104232",
      "poi_miles_from_property": "24.7",
      "poi_walking_minutes": "9 hours 13 mins",
      "poi_biking_minutes": "2 hours 52 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 816-243-5237",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-0a5a-743c-b6fd-1080ec01155b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-0a5a-743c-b6fd-1080ec01155b",
        "storage_key": "property/6767906449167623/019ff6a1-0a5a-743c-b6fd-1080ec01155b.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJmYfmiAhewIcRoNouXRnQzcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_f092eb56-286e-47da-a943-bad9c2e02b4a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "LAZ Parking - West Bottoms",
      "poi_type": "Transportation & Transit",
      "poi_address": "1601 State Line Rd, Kansas City, MO 64102, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b671-80d1-7654-9222-75bc7f0ae7c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-80d1-7654-9222-75bc7f0ae7c0",
        "storage_key": "property/6767906449167623/01a0b671-80d1-7654-9222-75bc7f0ae7c0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://lazparking.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11356123891337978856&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "laz-parking---west-bottoms",
      "poi_latitude": "39.0960782",
      "poi_longitude": "-94.6069912",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-472-5997",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b671-8ce3-7178-b15c-66b109b51255.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0b671-8ce3-7178-b15c-66b109b51255",
        "storage_key": "property/6767906449167623/01a0b671-8ce3-7178-b15c-66b109b51255.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJy4mhFxbxwIcR6OOGCIMOmZ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_garage"
    },
    {
      "id": "custom_4a99b911-a7bc-4cf4-b783-38b33604b306",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "UMKC Administrative Center Conference Facilities",
      "poi_type": "Entertainment",
      "poi_address": "5115 Oak St, Kansas City, MO 64112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6be-2cf9-771c-90b6-8268a74d2ab3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6be-2cf9-771c-90b6-8268a74d2ab3",
        "storage_key": "property/6767906449167623/019ff6be-2cf9-771c-90b6-8268a74d2ab3.webp",
        "width": 1280,
        "height": 665
      },
      "poi_business_url": "https://www.umkc.edu/accf/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5425826626236633289&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "umkc-administrative-center-conference-facilities",
      "poi_latitude": "39.0338939",
      "poi_longitude": "-94.5823404",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-235-5982",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-077b-7221-8ccd-5832925f91c3",
        "storage_key": "property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV_fd7ZfvwIcRydCwvZFoTEs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_af4ad4f2-e92d-4afe-bc70-9720ee01408a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "American Century Investments",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4400 Main St, Kansas City, MO 64111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6be-2b47-716a-a2aa-7eaea26840bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6be-2b47-716a-a2aa-7eaea26840bb",
        "storage_key": "property/6767906449167623/019ff6be-2b47-716a-a2aa-7eaea26840bb.webp",
        "width": 1280,
        "height": 389
      },
      "poi_business_url": "https://www.americancentury.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5277441427661296472&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "american-century-investments",
      "poi_latitude": "39.0459098",
      "poi_longitude": "-94.5874404",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-531-5575",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-077b-7221-8ccd-5832925f91c3",
        "storage_key": "property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7ciW3sDvwIcRWJOucgQ9PUk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "finance"
    },
    {
      "id": "custom_32d51cfe-e442-48a1-b9e3-83ad5fed2b1b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Children's Mercy Adele Hall Campus",
      "poi_type": "Health and Wellness",
      "poi_address": "2401 Gillham Rd, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019fc994-befe-7408-a429-b40ff1f680bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-befe-7408-a429-b40ff1f680bd",
        "storage_key": "property/6767906449167623/019fc994-befe-7408-a429-b40ff1f680bd.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.childrensmercy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=241680805565643787&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-mercy-adele-hall-campus",
      "poi_latitude": "39.08387889999999",
      "poi_longitude": "-94.5771759",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-234-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-0836-7779-aa4f-fb3b932df7ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-0836-7779-aa4f-fb3b932df7ac",
        "storage_key": "property/6767906449167623/019ff6a1-0836-7779-aa4f-fb3b932df7ac.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9zZsZRPwwIcRCzzFhGmfWgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_9329e5d9-82b7-41ec-a64c-0a63610f61f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "University Health Truman Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "2301 Holmes St, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019fc995-1482-714a-ae4b-950c2f070c83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-1482-714a-ae4b-950c2f070c83",
        "storage_key": "property/6767906449167623/019fc995-1482-714a-ae4b-950c2f070c83.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.universityhealthkc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3094198644431175220&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-health-truman-medical-center",
      "poi_latitude": "39.0841581",
      "poi_longitude": "-94.5752125",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-404-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-0836-7779-aa4f-fb3b932df7ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-0836-7779-aa4f-fb3b932df7ac",
        "storage_key": "property/6767906449167623/019ff6a1-0836-7779-aa4f-fb3b932df7ac.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJidv_PG3wwIcRNL7Q-UXN8Co",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_c7b574bb-7390-4d01-8c8c-774194cc82c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Hallmark Corporate",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2501 McGee St, Kansas City, MO 64108, USA",
      "poi_short_description": "Retail chain specializing in greeting cards, gift wrap, ornaments & gifts for all occasions.",
      "poi_long_description": "Retail chain specializing in greeting cards, gift wrap, ornaments & gifts for all occasions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019fc991-ff6b-7274-9944-094453463af3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc991-ff6b-7274-9944-094453463af3",
        "storage_key": "property/6767906449167623/019fc991-ff6b-7274-9944-094453463af3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://corporate.hallmark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1199437302719612463&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hallmark-corporate",
      "poi_latitude": "39.0811114",
      "poi_longitude": "-94.5800029",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-425-5627",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-077b-7221-8ccd-5832925f91c3",
        "storage_key": "property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjzp5phbwwIcRL4b0Nt9BpRA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_ac94b766-fd22-4f89-b03f-86ca8f868bf8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "H&R Block",
      "poi_type": "Major Employers & Offices",
      "poi_address": "One H and R, Block Way, Kansas City, MO 64105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019fc995-3168-72da-8026-6f619e7cd663.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-3168-72da-8026-6f619e7cd663",
        "storage_key": "property/6767906449167623/019fc995-3168-72da-8026-6f619e7cd663.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hrblock.com/tax-offices/local/missouri-tax-preparation/kansas-city-tax-professionals/?otppartnerid=9308&campaignid=pw_mcm_9308_9762&utm_medium=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=17520317420083081084&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hr-block",
      "poi_latitude": "39.0982642",
      "poi_longitude": "-94.5829906",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-854-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-077b-7221-8ccd-5832925f91c3",
        "storage_key": "property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB8i63JCKwIcRfO8j8N2rJPM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    },
    {
      "id": "custom_2818d3bf-ea88-4fb3-8ac8-4983e2702d95",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Lockton",
      "poi_type": "Major Employers & Offices",
      "poi_address": "444 W 47th St #900, Kansas City, MO 64112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b671-86da-75e8-9b26-e713b1ee47fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-86da-75e8-9b26-e713b1ee47fc",
        "storage_key": "property/6767906449167623/01a0b671-86da-75e8-9b26-e713b1ee47fc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://global.lockton.com/offices/us-kansas-city-headquarters",
      "poi_directions_map_url": "https://maps.google.com/?cid=2578382631270115552&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lockton",
      "poi_latitude": "39.0427697",
      "poi_longitude": "-94.59296100000002",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-960-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-077b-7221-8ccd-5832925f91c3",
        "storage_key": "property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJObI1EbjvwIcR4Gjkn1dByCM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "insurance_agency"
    },
    {
      "id": "custom_57b43918-a287-4abd-bd1f-1e22f6121280",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Burns & McDonnell",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9400 Ward Pkwy, Kansas City, MO 64114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6be-2b99-76f9-8aa3-1bbf1be3bc1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6be-2b99-76f9-8aa3-1bbf1be3bc1a",
        "storage_key": "property/6767906449167623/019ff6be-2b99-76f9-8aa3-1bbf1be3bc1a.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "http://www.burnsmcd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12200015508632981471&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "burns--mcdonnell",
      "poi_latitude": "38.9581441",
      "poi_longitude": "-94.5989227",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 816-333-9400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-077b-7221-8ccd-5832925f91c3",
        "storage_key": "property/6767906449167623/019ff6a1-077b-7221-8ccd-5832925f91c3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ20Zyr-DowIcR309TdncpT6k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_2404a6ff-1d32-4b87-95ca-8ad151059e97",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "custom",
      "poi_name": "Stowers Institute for Medical Research",
      "poi_type": "Education",
      "poi_address": "1000 E 50th St, Kansas City, MO 64110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019fc995-3928-721b-a979-8fe7c94d6d37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-3928-721b-a979-8fe7c94d6d37",
        "storage_key": "property/6767906449167623/019fc995-3928-721b-a979-8fe7c94d6d37.webp",
        "width": 1280,
        "height": 930
      },
      "poi_business_url": "http://www.stowers.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14221194027749611628&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stowers-institute-for-medical-research",
      "poi_latitude": "39.0365098",
      "poi_longitude": "-94.5742972",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-926-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/019ff6a1-082a-74ce-93b0-7f197befc21f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-082a-74ce-93b0-7f197befc21f",
        "storage_key": "property/6767906449167623/019ff6a1-082a-74ce-93b0-7f197befc21f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ1aC1p5HvwIcRbBjsAZ_UW8U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "research_institute"
    }
  ],
  "office_hours": [
    {
      "id": "ec_b76ab339d0309490545dcda6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_a0190ca14a7aa1c55bdfbe47",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_23bcb0123728418ef4b390e8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_7d92d6f0dc92609e045ca8b1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_21bd0f4beb51a4d79b4588ac",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "ec_fce7f9afeafe71486913b5fb",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "rating": "5",
      "name": "Nate Sekuna",
      "text": "Met and had a tour with Maya and Allie last week or the week before they both were really nice and fun to be around while touring and gave me snacks ! Recommend checking the apartment out.\n\nThe apartments have really nice finishes very nice looking apartments and I like how they have a washer and dryer in the apartments. nice size gym too. Hope to get moved in soon I hope they have openings for Aug or sept.",
      "date": "2025-05-01",
      "title": "false"
    },
    {
      "id": "ec_3b67f6080b94b7bcede215b1",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "rating": "5",
      "name": "Adam Wetzel",
      "text": "Great location, especially if you work at the University of Kansas Medical Center, as it is within walking distance. Many unique and diverse eating and shopping experiences are also within walking distance. Additionally, the apartment management provides excellent customer service and is always very responsive in resolving concerns.",
      "date": "2020-08-02",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_1b473b92492c5d866d09f012",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b679-b1be-7099-9899-3d38539146e3.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b679-b1be-7099-9899-3d38539146e3",
        "storage_key": "property/6767906449167623/01a0b679-b1be-7099-9899-3d38539146e3.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "BELL",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Vd7tBQb9MWY"
    },
    {
      "id": "ec_71b5a7a7598a96f6fc76ca9b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b679-7d3c-72a9-a182-b4591b9e3513.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b679-7d3c-72a9-a182-b4591b9e3513",
        "storage_key": "property/6767906449167623/01a0b679-7d3c-72a9-a182-b4591b9e3513.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "LORRETTO",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=AMorRMMotkm"
    },
    {
      "id": "ec_b25219a4cebb0d9b94bb73c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b679-c2e2-7676-b4cb-5ab521a986fd.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b679-c2e2-7676-b4cb-5ab521a986fd",
        "storage_key": "property/6767906449167623/01a0b679-c2e2-7676-b4cb-5ab521a986fd.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "VALENTINE",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=rkAGgEcek7N"
    },
    {
      "id": "ec_48767e4c3e6d32d6d8b0ad9e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "West 39th St Apts\nRoselawn - 1 bed, 1 bath, 607sqft.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b679-7d52-7457-a077-f0d8be7896a9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b679-7d52-7457-a077-f0d8be7896a9",
        "storage_key": "property/6767906449167623/01a0b679-7d52-7457-a077-f0d8be7896a9.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "ROSELAWN",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=BSdYdv9WMLQ"
    },
    {
      "id": "ec_d840d9a6eca4c46b2639e4e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b679-8075-717c-baa7-0bd71a43a32c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b679-8075-717c-baa7-0bd71a43a32c",
        "storage_key": "property/6767906449167623/01a0b679-8075-717c-baa7-0bd71a43a32c.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "BROADWAY",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=JZEH62HsrsQ"
    },
    {
      "id": "ec_9b883b5807a03528519ec6c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b679-d7f7-711f-a3c4-bdbc1db5bbac.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b679-d7f7-711f-a3c4-bdbc1db5bbac",
        "storage_key": "property/6767906449167623/01a0b679-d7f7-711f-a3c4-bdbc1db5bbac.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "GENESSEE",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=AsMPbMXS3Gv"
    },
    {
      "id": "ec_bf6892c95a88bd8bf8c1bfc8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "West 39th St Apartments\nThe Volker - 2 bed, 2 bath, 923sqft.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b679-d5d4-73ab-9bd5-addadf0c3aaf.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b679-d5d4-73ab-9bd5-addadf0c3aaf",
        "storage_key": "property/6767906449167623/01a0b679-d5d4-73ab-9bd5-addadf0c3aaf.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "VOLKER",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=LoFdT6hfY3P"
    },
    {
      "id": "ec_84b566595dc8cdf7ef20b14f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "West 39th St Apartments\nThe Roanoke - 2 bed, 2 bath, 1007 sqft.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167623/01a0b679-d264-70a0-baf2-ae5825a6aa8f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b679-d264-70a0-baf2-ae5825a6aa8f",
        "storage_key": "property/6767906449167623/01a0b679-d264-70a0-baf2-ae5825a6aa8f.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "ROANOKE",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=CYSZked4Xxk"
    }
  ],
  "faqs": [
    {
      "id": "custom_0816ab91-4630-45a6-98a8-24f92737999a",
      "question": "How do I apply?",
      "answer": "Click on the <a href=\"/apply-now\">Apply Now</a> button under the <a href=\"/floor-plans\">Floor Plans</a> tab of our community website.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_0b9f565d-4b8e-48d1-9f22-3a271ed9e382",
      "question": "Are there different lease term options available?",
      "answer": "Yes, we offer various lease term options. Please <a href=\"/contact-us\">contact our office</a> for more details.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_0d4f82f0-6f8d-41d5-9208-f53162f7885a",
      "question": "Do I need an appointment to take a tour?",
      "answer": "No appointment is necessary to tour our community during business hours; however, it is always appreciated if you call ahead to make sure we are available to provide adequate time for you to tour and ask questions. It is recommended to arrive no later than one half hour prior to closing if you would like to tour the community. Everyone over 18 years of age must have a valid photo ID to tour. Valid forms of identification are decided by Price Brothers Management Company and may include items such as: US Driver’s License, US State Photo ID, US Military Photo ID, US Visa with Photo ID upon it, US Citizenship and Immigration Services Photo ID, Passport.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_f365cbe6-e7b0-4cb3-873f-72cb633f983e",
      "question": "Do you allow pets?",
      "answer": "Our community is happy to accept cats and dogs. Please refer to our pet section on the <a href=\"/pet-policy\">Pet Policy</a> page.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_e1d592fe-f6d7-4096-bb30-436788feb08e",
      "question": "Why does your pricing include ranges?",
      "answer": "The prices will range on each floor plan depending on finishes, views, and other features inside the apartment home.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_e90d0201-d5b8-4f9c-b3a0-7a200eb09a40",
      "question": "How can I refer a friend?",
      "answer": "If you love living here and want to refer a friend, please let our office know! We offer resident referral programs throughout the year and would love for your friends and family to join our community.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_d7102649-6a27-48dd-8f81-0a4de1af6a8b",
      "question": "What is the application fee and is it refundable?",
      "answer": "Application fees are due for each person 18 and older occupying the apartment. All application fees are nonrefundable.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_048997d0-d7d3-4da6-ac74-556dee45dc90",
      "question": "What is a holding deposit or earnest money?",
      "answer": "A \"holding\" deposit or \"earnest money\" is another word for \"security\" deposit. Please <a href=\"/contact-us\">contact our leasing office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_95fe298f-3500-4807-a475-120f5a445d62",
      "question": "What utilities am I responsible to pay?",
      "answer": "Our residents are responsible to pay for water, trash, and electric.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_7fcb6e51-8bbd-4025-af75-8572243fabc0",
      "question": "Do you require renters insurance?",
      "answer": "All residents are required to maintain a minimum of $100,000 in liability coverage as part of their lease agreement. For more details on coverage requirements and available options, please <a href=\"/contact-us\">contact our leasing office</a>.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_a35beb4a-8de9-4298-9720-e0a84a5b335c",
      "question": "How can I pay my rent?",
      "answer": "You can pay rent by accessing your <a href=\"/resident-access\">resident online account</a>. This allows you to use a bank account or credit card to make payments.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_25d34605-e555-479f-8c7e-06091c37c666",
      "question": "Do you offer flexible rent payment options?",
      "answer": "Yes! We’ve partnered with Flex to make paying rent easier for our residents. Flex allows you to split your rent into smaller, more manageable payments throughout the month, giving you added financial flexibility. For more details or to sign up, <a href=\"/contact-us\">contact our leasing office</a> today!",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_ab85d4fd-1a00-4929-b35b-364cfc3fa458",
      "question": "Do you offer covered parking?",
      "answer": "Yes, we offer underground parking. 1 bedroom apartment homes receive 1 parking spot, 2 bedroom apartment homes receive 2 parking spots.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_abcbcc8d-6796-44dd-820e-472770aea6f8",
      "question": "Do you host events at your property?",
      "answer": "Yes, we host events throughout the year with various activities to encourage community camaraderie.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_823dae81-0407-48bb-83c5-bc3699ecf133",
      "question": "Do you accept packages on behalf of the residents?",
      "answer": "No, we do not offer this service at this time.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_b554a76b-0d1a-47fe-993c-33df5d4a516b",
      "question": "If something needs to be repaired in my apartment, how do I report it?",
      "answer": "You may call the office or submit work orders online by accessing your <a href=\"/resident-access\">resident account</a>. All emergency repairs should be reported by <a href=\"/contact-us\">contacting the office</a>. If the emergency is being reported after business hours, please follow the prompts to be connected to the answering service.",
      "category": "Maintenance",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0c9ac-5330-735e-98cc-e0cda79b39f0",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "West 39th Street Apartments Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623"
    },
    {
      "lead_collector_id": "01a0c9ac-53a3-76a1-95bd-d3690401baf0",
      "lead_source": "LANDING_PAGE",
      "name": "West 39th Street Apartments Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-kansas-city-mo",
      "search_query": "in unit laundry apartments Kansas City MO",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in Kansas City MO",
      "h2_subtitle": "Experience the ease of having in-unit laundry at West 39th Street Apartments. Enjoy the convenience in Kansas City, MO's bustling Midtown.",
      "page_copy": "At West 39th Street Apartments, discover the luxury of in-unit laundry apartments in Kansas City, MO. Our polished one- and two-bedroom floor plans offer a seamless blend of comfort and style, complete with included garage parking. Situated in the heart of Midtown - Westport, you’ll be steps away from vibrant dining, chic coffee spots, and eclectic boutiques. \n\nEmbrace the practicality of in-unit laundry, allowing you time to enjoy Kansas City’s local treasures. With features like 11-foot ceilings, modern ovens, and a designated bark park, West 39th Street Apartments makes everyday life both convenient and enjoyable. Schedule a tour to explore how our amenities can enhance your lifestyle today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167623/01a0b670-1d6b-76b0-a914-dfddf4ac648b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of West 39th apartment building at sunset with a vibrant sky and street view.",
        "public_id": "01a0b670-1d6b-76b0-a914-dfddf4ac648b",
        "storage_key": "property/6767906449167623/01a0b670-1d6b-76b0-a914-dfddf4ac648b.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments in Kansas City MO",
      "seo_description": "West 39th Street Apartments offers in-unit laundry in Kansas City, MO. Enjoy modern living with a convenient Midtown - Westport location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-midtown-westport",
      "search_query": "dog friendly apartments Midtown Westport",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments in Midtown Westport",
      "h2_subtitle": "Explore pet-friendly living at West 39th Street Apartments in Midtown - Westport. Your furry friends are welcome here!",
      "page_copy": "West 39th Street Apartments proudly presents dog-friendly apartments in Midtown - Westport, where both you and your four-legged friends can thrive. Located in Kansas City, our community offers a vibrant lifestyle enhanced by unique amenities, including a dedicated bark park. Here, you and your pet have the ideal setting to play and unwind.\n\nOur one- and two-bedroom homes combine modern convenience with stylish comfort, featuring essentials like included garage parking, 11-foot ceilings, and spacious layouts. Nestled in a walkable neighborhood, you'll find quick access to trendy dining spots, cozy coffee shops, and charming boutiques. Discover the perfect home for you and your pet by scheduling a tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167623/01a0b670-1d6b-76b0-a914-dfddf4ac648b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of West 39th apartment building at sunset with a vibrant sky and street view.",
        "public_id": "01a0b670-1d6b-76b0-a914-dfddf4ac648b",
        "storage_key": "property/6767906449167623/01a0b670-1d6b-76b0-a914-dfddf4ac648b.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments Midtown Westport",
      "seo_description": "Find dog-friendly living at West 39th Street Apartments in Midtown - Westport, Kansas City. Enjoy a welcoming community with pet amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "generator",
      "page_item_url": "apartments-garage-parking-near-ku-medical-center",
      "search_query": "apartments with garage parking near KU Medical Center",
      "category": "Amenity",
      "h1_title": "Apartments with Garage Parking near KU Medical Center",
      "h2_subtitle": "Discover convenient apartments with garage parking at West 39th Street Apartments, just minutes from KU Medical Center.",
      "page_copy": "West 39th Street Apartments offers the perfect solution for those seeking apartments with garage parking near KU Medical Center. Our location in Kansas City's Midtown - Westport neighborhood provides seamless access to both work and leisure. Enjoy the peace of mind that comes with secure garage parking without sacrificing proximity to KU Medical Center.\n\nExperience modern living with thoughtful amenities such as spacious one- and two-bedroom floor plans, 11-foot ceilings, and convenient access to local dining, coffee shops, and boutiques. Our pet-friendly community also features a bark park, ensuring that both you and your furry companions feel at home. Schedule a tour today to explore how our community could fit your lifestyle needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167623/01a0b670-1d6b-76b0-a914-dfddf4ac648b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of West 39th apartment building at sunset with a vibrant sky and street view.",
        "public_id": "01a0b670-1d6b-76b0-a914-dfddf4ac648b",
        "storage_key": "property/6767906449167623/01a0b670-1d6b-76b0-a914-dfddf4ac648b.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Garage Parking near KU Medical Center",
      "seo_description": "West 39th Street Apartments offers garage parking near KU Medical Center. Enjoy modern living in Midtown - Westport.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-jackson-county",
      "search_query": "air conditioned apartments in Jackson County",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Jackson County",
      "h2_subtitle": "Stay comfortable year-round at West 39th Street Apartments in Jackson County. Our air-conditioned homes offer comfort and convenience.",
      "page_copy": "Enjoy ultimate comfort in air-conditioned apartments at West 39th Street Apartments, nestled in the heart of Jackson County's vibrant Midtown - Westport neighborhood. With modern one- and two-bedroom floor plans, our community is designed to provide you with a refreshing escape all year long.\n\nOur community features include not just air conditioning, but also high-quality amenities such as 11-foot ceilings, garage parking, and a welcoming bark park. Situated within walking distance to lively dining spots and trendy boutiques, you'll have all of Kansas City's famed attractions at your doorstep. Schedule a tour today to experience the perfect blend of comfort and convenience in your next home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167623/01a0b670-1d6b-76b0-a914-dfddf4ac648b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of West 39th apartment building at sunset with a vibrant sky and street view.",
        "public_id": "01a0b670-1d6b-76b0-a914-dfddf4ac648b",
        "storage_key": "property/6767906449167623/01a0b670-1d6b-76b0-a914-dfddf4ac648b.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in Jackson County",
      "seo_description": "Find comfort at West 39th Street Apartments in Jackson County. Enjoy air-conditioned living in the lively Midtown - Westport area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "generator",
      "page_item_url": "luxury-apartments-fitness-center-64111",
      "search_query": "luxury apartments with fitness center 64111",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Fitness Center in 64111",
      "h2_subtitle": "Discover upscale living at West 39th Street Apartments, featuring a modern fitness center, right in the heart of the 64111 area.",
      "page_copy": "Experience the epitome of upscale living with luxury apartments featuring a state-of-the-art fitness center at West 39th Street Apartments in the vibrant 64111 zip code. Nestled in Kansas City's sought-after Midtown - Westport neighborhood, our community seamlessly combines elegance with modern amenities.\n\nOur thoughtfully designed one- and two-bedroom residences boast impressive 11-foot ceilings, premium appliances like dishwashers and ovens, and included garage parking for your convenience. Beyond the comfort of your apartment, enjoy on-site amenities such as a bark park and bicycle storage. With easy access to local dining, coffee shops, and boutiques, you'll be living in luxury both indoors and out. Schedule a tour today to see how West 39th Street Apartments can elevate your lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167623/01a0b670-1d6b-76b0-a914-dfddf4ac648b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of West 39th apartment building at sunset with a vibrant sky and street view.",
        "public_id": "01a0b670-1d6b-76b0-a914-dfddf4ac648b",
        "storage_key": "property/6767906449167623/01a0b670-1d6b-76b0-a914-dfddf4ac648b.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Fitness Center in 64111",
      "seo_description": "West 39th Street Apartments offers luxury living with a fitness center in 64111, Midtown - Westport. Discover elegance and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "generator",
      "page_item_url": "1-bedroom-apartment-midtown-kansas-city",
      "search_query": "1 bedroom apartment midtown kansas city",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartment in Midtown Kansas City",
      "h2_subtitle": "Find your new 1 bedroom apartment at West 39th Street Apartments, ideally located in Midtown Kansas City.",
      "page_copy": "Looking for a 1 bedroom apartment in the bustling Midtown Kansas City area? West 39th Street Apartments offers polished one-bedroom floor plans ideal for anyone seeking both comfort and convenience. Located in the thriving Midtown - Westport neighborhood, our community connects you effortlessly with the best of Kansas City.\n\nEach apartment is thoughtfully designed with high 11-foot ceilings and modern amenities like dishwashers and ovens. Our community features include garage parking, a bark park for your pets, and nearby bicycle storage. With dining, coffee shops, and boutiques within walking distance, living at West 39th Street Apartments means enjoying the dynamic energy of Kansas City right at your doorstep. Schedule a tour today and discover how a one-bedroom home here can fit your lifestyle perfectly.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167623/01a0b670-1d6b-76b0-a914-dfddf4ac648b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of West 39th apartment building at sunset with a vibrant sky and street view.",
        "public_id": "01a0b670-1d6b-76b0-a914-dfddf4ac648b",
        "storage_key": "property/6767906449167623/01a0b670-1d6b-76b0-a914-dfddf4ac648b.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartment in Midtown Kansas City",
      "seo_description": "Discover modern 1 bedroom apartments at West 39th Street Apartments in Midtown Kansas City, offering convenient amenities and a vibrant lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "generator",
      "page_item_url": "2-bedroom-apts-westport-kansas-city-mo",
      "search_query": "2 bedroom apts westport kansas city mo",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apts in Westport, Kansas City, MO",
      "h2_subtitle": "Explore spacious 2 bedroom apts at West 39th Street Apartments, located in the heart of Westport, Kansas City, MO.",
      "page_copy": "Discover the ideal living space with our spacious 2 bedroom apts at West 39th Street Apartments, positioned right in the lively Westport neighborhood of Kansas City, MO. Each apartment is designed to offer you the perfect balance of style and function with ample room to live and entertain.\n\nOur community provides an exceptional array of amenities, including in-unit dishwashers and ovens, bicycle storage, and a welcoming bark park for pet owners. The generous 11-foot ceilings add an airy elegance to each home. Located in the ever-active Midtown - Westport area, you'll find yourself steps away from exquisite local dining, charming coffee shops, and unique boutiques. Schedule a visit today to see how West 39th Street Apartments can be the perfect home for you.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167623/01a0b670-1d6b-76b0-a914-dfddf4ac648b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of West 39th apartment building at sunset with a vibrant sky and street view.",
        "public_id": "01a0b670-1d6b-76b0-a914-dfddf4ac648b",
        "storage_key": "property/6767906449167623/01a0b670-1d6b-76b0-a914-dfddf4ac648b.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apts in Westport, Kansas City, MO",
      "seo_description": "Spacious 2 bedroom apts at West 39th Street Apartments in Westport, Kansas City, MO. Enjoy stylish living with top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "generator",
      "page_item_url": "apartments-near-kansas-city-art-institute",
      "search_query": "apartments near kansas city art institute",
      "category": "School",
      "h1_title": "Apartments Near Kansas City Art Institute",
      "h2_subtitle": "Live close to creativity at West 39th Street Apartments, conveniently located near the Kansas City Art Institute.",
      "page_copy": "Embrace a lifestyle imbued with art and culture by choosing an apartment near the Kansas City Art Institute at West 39th Street Apartments. Our community places you in proximity to one of Kansas City's most prestigious art schools, allowing you to soak in the vibrant local art scene.\n\nOur one- and two-bedroom residences are not only conveniently located in the Midtown - Westport neighborhood, but also offer luxurious amenities like high 11-foot ceilings, in-unit dishwashers, and garage parking. With a bark park and bicycle storage, our property provides everything you need for a comfortable and modern lifestyle. Enjoy easy access to myriad dining options, coffee shops, and boutiques, making West 39th Street Apartments the perfect home base for art enthusiasts and students alike.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167623/01a0b670-1d6b-76b0-a914-dfddf4ac648b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of West 39th apartment building at sunset with a vibrant sky and street view.",
        "public_id": "01a0b670-1d6b-76b0-a914-dfddf4ac648b",
        "storage_key": "property/6767906449167623/01a0b670-1d6b-76b0-a914-dfddf4ac648b.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Kansas City Art Institute",
      "seo_description": "Live near the Kansas City Art Institute at West 39th Street Apartments, offering modern amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "generator",
      "page_item_url": "apartments-close-to-plaza-academy-midtown-kc",
      "search_query": "apartments close to plaza academy midtown kc",
      "category": "School",
      "h1_title": "Apartments Close to Plaza Academy, Midtown KC",
      "h2_subtitle": "Discover modern living near Plaza Academy in Midtown KC with West 39th Street Apartments, offering convenient and stylish home options.",
      "page_copy": "Situated near Plaza Academy in Midtown KC, West 39th Street Apartments provides a comfortable and convenient living experience for those seeking proximity to education and vibrant city life. With walkable access to essential amenities and services, these apartments make everyday living effortlessly efficient.\n\nOur community offers both one- and two-bedroom floor plans with impressive features including soaring 11-foot ceilings and modern appliances like dishwashers and ovens. Residents also enjoy exclusive amenities such as garage parking, a pet-friendly bark park, and secure bicycle storage. Surrounded by popular dining spots and eclectic boutiques, living here means enjoying the dynamic energy of Kansas City while staying close to Plaza Academy. Schedule a tour today to experience this ideal location for yourself.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167623/01a0b670-1d6b-76b0-a914-dfddf4ac648b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of West 39th apartment building at sunset with a vibrant sky and street view.",
        "public_id": "01a0b670-1d6b-76b0-a914-dfddf4ac648b",
        "storage_key": "property/6767906449167623/01a0b670-1d6b-76b0-a914-dfddf4ac648b.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Plaza Academy, Midtown KC",
      "seo_description": "Find stylish apartments near Plaza Academy, Midtown KC at West 39th Street Apartments, featuring convenient amenities and a vibrant location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "generator",
      "page_item_url": "university-of-missouri-kansas-city-nearby-apartments",
      "search_query": "university of missouri-kansas city nearby apartments",
      "category": "School",
      "h1_title": "University of Missouri-Kansas City Nearby Apartments",
      "h2_subtitle": "Find stylish nearby apartments at West 39th Street Apartments, just minutes from the University of Missouri-Kansas City.",
      "page_copy": "Experience the ideal blend of university convenience and urban lifestyle at West 39th Street Apartments, located just a short distance from the University of Missouri-Kansas City. Our community offers a perfect living solution for students and professionals who appreciate being close to the academic hub while enjoying the perks of city living.\n\nWe feature polished one- and two-bedroom layouts equipped with top-notch amenities like towering 11-foot ceilings, modern ovens, and in-unit dishwashers. Residents benefit from exclusive access to amenities including a spacious garage for parking and a dedicated bark park for pet lovers. Situated in the vibrant Midtown - Westport area, our community places you mere moments away from a variety of dining options, charming cafes, and exciting shopping spots. Make your move to West 39th Street Apartments today and embrace the dynamic Kansas City experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167623/01a0b670-1d6b-76b0-a914-dfddf4ac648b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of West 39th apartment building at sunset with a vibrant sky and street view.",
        "public_id": "01a0b670-1d6b-76b0-a914-dfddf4ac648b",
        "storage_key": "property/6767906449167623/01a0b670-1d6b-76b0-a914-dfddf4ac648b.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "University of Missouri-Kansas City Nearby Apartments",
      "seo_description": "Live near University of Missouri-Kansas City at West 39th Street Apartments. Enjoy modern amenities and a prime city location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "generator",
      "page_item_url": "rockhurst-university-jackson-county-apartments",
      "search_query": "rockhurst university jackson county apartments",
      "category": "School",
      "h1_title": "Rockhurst University Jackson County Apartments",
      "h2_subtitle": "West 39th Street Apartments offers modern living just a short drive from Rockhurst University in Jackson County.",
      "page_copy": "Discover the convenience of living near Rockhurst University at West 39th Street Apartments, located in the heart of Jackson County. Perfect for students and faculty, our community is just minutes from campus, allowing you quick access to classes and university events.\n\nOur one- and two-bedroom apartments boast spacious living with features like soaring 11-foot ceilings and modern appliances, including dishwashers and ovens. Enjoy amenities such as secure garage parking, a bicycle storage area, and a bark park for your furry friends. Nestled in the lively Midtown - Westport neighborhood, these apartments provide immediate access to an array of dining and shopping experiences. Enhance your Kansas City lifestyle by making West 39th Street Apartments your home base today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167623/01a0b670-1d6b-76b0-a914-dfddf4ac648b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of West 39th apartment building at sunset with a vibrant sky and street view.",
        "public_id": "01a0b670-1d6b-76b0-a914-dfddf4ac648b",
        "storage_key": "property/6767906449167623/01a0b670-1d6b-76b0-a914-dfddf4ac648b.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rockhurst University Jackson County Apartments",
      "seo_description": "Find stylish apartments near Rockhurst University at West 39th Street Apartments in Jackson County. Enjoy modern amenities in a vibrant location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "generator",
      "page_item_url": "apartments-by-pembroke-hill-school-kc",
      "search_query": "apartments by pembroke hill school kc",
      "category": "School",
      "h1_title": "Apartments by Pembroke Hill School, KC",
      "h2_subtitle": "West 39th Street Apartments offers a stylish home base near Pembroke Hill School in Kansas City.",
      "page_copy": "Located near Pembroke Hill School in Kansas City, West 39th Street Apartments provides a perfect combination of academic proximity and urban convenience. Ideal for families and educators seeking a home close to the renowned school, our community ensures easy commuting alongside exciting neighborhood experiences.\n\nChoose from our sophisticated one- and two-bedroom floor plans, featuring luxurious details like 11-foot ceilings and up-to-date appliances including ovens and dishwashers. Residents enjoy on-site amenities such as secure garage parking, bicycle storage, and a pet-friendly bark park. Nestled within the vibrant Midtown - Westport area, these apartments offer easy access to local dining, boutiques, and more, making it an ideal place to connect with the energetic Kansas City atmosphere. Explore everything we have to offer by scheduling a tour today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167623/01a0b670-1d6b-76b0-a914-dfddf4ac648b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of West 39th apartment building at sunset with a vibrant sky and street view.",
        "public_id": "01a0b670-1d6b-76b0-a914-dfddf4ac648b",
        "storage_key": "property/6767906449167623/01a0b670-1d6b-76b0-a914-dfddf4ac648b.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Pembroke Hill School, KC",
      "seo_description": "Live near Pembroke Hill School, KC at West 39th Street Apartments. Enjoy modern living and amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "generator",
      "page_item_url": "ewing-marion-kauffman-school-surrounding-apartments",
      "search_query": "ewing marion kauffman school surrounding apartments",
      "category": "School",
      "h1_title": "Apartments Near Ewing Marion Kauffman School",
      "h2_subtitle": "Choose West 39th Street Apartments for comfortable and accessible living near Ewing Marion Kauffman School in Kansas City.",
      "page_copy": "West 39th Street Apartments offers an ideal living solution close to Ewing Marion Kauffman School, providing both comfort and convenience for families and educators. Our location allows you to enjoy quick and easy commutes while being part of the vibrant Kansas City community.\n\nOur selection of one- and two-bedroom apartments is designed to impress, featuring modern amenities like high 11-foot ceilings and equipped kitchens with dishwashers and ovens. Residents relish the advantages of secure garage parking, bicycle storage facilities, and a welcoming bark park for pets. Positioned in the bustling Midtown - Westport neighborhood, our community connects you with a lively area full of dining and shopping venues. Make West 39th Street Apartments your home and experience the ease of city living combined with suburban peace.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167623/01a0b670-1d6b-76b0-a914-dfddf4ac648b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of West 39th apartment building at sunset with a vibrant sky and street view.",
        "public_id": "01a0b670-1d6b-76b0-a914-dfddf4ac648b",
        "storage_key": "property/6767906449167623/01a0b670-1d6b-76b0-a914-dfddf4ac648b.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Ewing Marion Kauffman School",
      "seo_description": "Find your home near Ewing Marion Kauffman School at West 39th Street Apartments. Experience modern amenities in a prime Kansas City location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "generator",
      "page_item_url": "primitivo-garcia-elementary-school-kansas-city-apartments",
      "search_query": "primitivo garcia elementary school kansas city apartments",
      "category": "School",
      "h1_title": "Apartments Near Primitivo Garcia Elementary, KC",
      "h2_subtitle": "West 39th Street Apartments provides family-friendly living near Primitivo Garcia Elementary School in Kansas City.",
      "page_copy": "Discover the perfect family residence at West 39th Street Apartments, ideally situated near Primitivo Garcia Elementary School in Kansas City. Enjoy the convenience of residing close to the school, making school runs hassle-free and participation in events effortless.\n\nOffering stylish one- and two-bedroom apartments, our community ensures a comfortable living environment with features like spacious 11-foot ceilings and modern kitchen appliances. Residents benefit from exceptional amenities such as garage parking, bicycle storage, and a dedicated bark park. Located in the vibrant Midtown - Westport area, West 39th Street Apartments keeps you connected to an array of local attractions including eateries and boutiques, making it a wonderful base for both educational and social activities in Kansas City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167623/01a0b670-1d6b-76b0-a914-dfddf4ac648b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of West 39th apartment building at sunset with a vibrant sky and street view.",
        "public_id": "01a0b670-1d6b-76b0-a914-dfddf4ac648b",
        "storage_key": "property/6767906449167623/01a0b670-1d6b-76b0-a914-dfddf4ac648b.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Primitivo Garcia Elementary, KC",
      "seo_description": "Live near Primitivo Garcia Elementary School at West 39th Street Apartments. Enjoy convenient access to education and local attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "generator",
      "page_item_url": "apartments-near-childrens-mercy-adele-hall-campus-kansas-city",
      "search_query": "apartments near children's mercy adele hall campus kansas city",
      "category": "Hospital",
      "h1_title": "Apartments Near Children's Mercy Adele Hall KC",
      "h2_subtitle": "Discover convenient living at West 39th Street Apartments, close to Children's Mercy Adele Hall Campus in Kansas City.",
      "page_copy": "West 39th Street Apartments offers an ideal location for those seeking residence near the Children's Mercy Adele Hall Campus in Kansas City. This proximity provides ease for healthcare professionals and families needing quick access to the hospital’s facilities.\n\nOur community offers meticulously designed one- and two-bedroom apartments, featuring amenities such as soaring 11-foot ceilings and updated kitchen appliances, including dishwashers and ovens. Residents enjoy a well-rounded lifestyle with exclusive amenities like secure garage parking, a bicycle storage area, and a charming bark park. Nestled in the lively Midtown - Westport neighborhood, West 39th Street Apartments connects you with Kansas City's finest dining and shopping options, ensuring a balanced work-life harmony.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167623/01a0b670-1d6b-76b0-a914-dfddf4ac648b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of West 39th apartment building at sunset with a vibrant sky and street view.",
        "public_id": "01a0b670-1d6b-76b0-a914-dfddf4ac648b",
        "storage_key": "property/6767906449167623/01a0b670-1d6b-76b0-a914-dfddf4ac648b.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Children's Mercy Adele Hall KC",
      "seo_description": "Find your home near Children's Mercy Adele Hall Campus at West 39th Street Apartments, offering comfort and convenience in Kansas City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "generator",
      "page_item_url": "apartments-close-to-university-health-truman-medical-center-kansas-city-mo",
      "search_query": "apartments close to university health truman medical center kansas city mo",
      "category": "Hospital",
      "h1_title": "Apartments Near University Health Truman KC",
      "h2_subtitle": "Experience close proximity to University Health Truman Medical Center at West 39th Street Apartments in Kansas City, MO.",
      "page_copy": "Nestled in the vibrant area of Midtown - Westport, West 39th Street Apartments offers excellent living options near University Health Truman Medical Center in Kansas City, MO. Perfect for healthcare workers and patients seeking comfort and convenience close to the medical center.\n\nOur selection of one- and two-bedroom apartments is ideal for those who value style and practicality, featuring high 11-foot ceilings, modern kitchens equipped with ovens and dishwashers, and more. Residents appreciate exclusive community perks such as garage parking, bicycle storage, and a dedicated bark park for pets. Enjoy the best of urban living with nearby access to Kansas City’s top dining, coffee shops, and boutiques, all just a short distance from the medical center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167623/01a0b670-1d6b-76b0-a914-dfddf4ac648b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of West 39th apartment building at sunset with a vibrant sky and street view.",
        "public_id": "01a0b670-1d6b-76b0-a914-dfddf4ac648b",
        "storage_key": "property/6767906449167623/01a0b670-1d6b-76b0-a914-dfddf4ac648b.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University Health Truman KC",
      "seo_description": "West 39th Street Apartments offers comfortable living near University Health Truman Medical Center in Kansas City, MO. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "generator",
      "page_item_url": "apartments-near-mill-creek-park-kansas-city",
      "search_query": "apartments near mill creek park kansas city",
      "category": "Park",
      "h1_title": "Apartments Near Mill Creek Park, Kansas City",
      "h2_subtitle": "West 39th Street Apartments offers the perfect location for enjoying green spaces near Mill Creek Park in Kansas City.",
      "page_copy": "Embrace vibrant living at West 39th Street Apartments, conveniently located near Mill Creek Park in Kansas City. This proximity provides residents with beautiful green spaces and recreational opportunities just steps from home.\n\nChoose from stylish one- and two-bedroom floor plans that feature high ceilings, modern conveniences like dishwashers, and plenty of natural light. Residents also benefit from unique amenities such as garage parking, bike storage, and a delightful bark park perfect for dogs. Located in the heart of the Midtown - Westport neighborhood, West 39th Street Apartments offers easy access to local cafes, shopping, and dining, along with the natural allure of nearby Mill Creek Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167623/01a0b670-1d6b-76b0-a914-dfddf4ac648b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of West 39th apartment building at sunset with a vibrant sky and street view.",
        "public_id": "01a0b670-1d6b-76b0-a914-dfddf4ac648b",
        "storage_key": "property/6767906449167623/01a0b670-1d6b-76b0-a914-dfddf4ac648b.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Mill Creek Park, Kansas City",
      "seo_description": "Find your home near Mill Creek Park at West 39th Street Apartments, offering a blend of urban convenience and access to Kansas City's green spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167623",
      "source": "generator",
      "page_item_url": "apartments-near-kansas-city-international-airport",
      "search_query": "apartments near kansas city international airport",
      "category": "Transit",
      "h1_title": "Apartments Near Kansas City International Airport",
      "h2_subtitle": "West 39th Street Apartments provides convenient living near Kansas City International Airport, combining ease of access with urban comforts.",
      "page_copy": "Located within a comfortable driving distance from Kansas City International Airport, West 39th Street Apartments offers an excellent living choice for frequent travelers and airport staff. Enjoy seamless access to both the airport and the bustling urban lifestyle of Kansas City.\n\nOur one- and two-bedroom apartments are designed with modern living in mind, featuring lofty ceilings, energy-efficient appliances, and secure amenities like garage parking. The community ensures convenience with bicycle storage, a pet-friendly bark park, and easy access to vibrant dining and shopping options in the Midtown - Westport neighborhood. Experience the blend of city life and travel convenience at our perfectly situated apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167623/01a0b670-1d6b-76b0-a914-dfddf4ac648b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of West 39th apartment building at sunset with a vibrant sky and street view.",
        "public_id": "01a0b670-1d6b-76b0-a914-dfddf4ac648b",
        "storage_key": "property/6767906449167623/01a0b670-1d6b-76b0-a914-dfddf4ac648b.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Kansas City International Airport",
      "seo_description": "West 39th Street Apartments offers urban living within reach of Kansas City International Airport, perfect for travelers and city lovers alike.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12701918312"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WLS9V7DS"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Batch 3"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Vantage"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/8a7d8f02-5be2-41aa-86cb-8cb1d2be93fa/app.js?nocache=1&gaTracking=G-5ZJF3NH02Y&buttonbgcolor=000000&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "816-992-5097"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjNyWHFCZ0c3OS84Tit2TGUvNXZySGc9PSIsInZhbHVlIjoieFdqSWlCSG9vYm4weWZEK0lZcUdwdz09IiwibWFjIjoiN2ZjMDk5ZjUwNGYzN2M4Y2NmYzRiNjY5ZDNlYTQyMGI5M2ZjZDE5MmIxYTAzMDI4NjdhMmRkNjgwZWYyMTUzMiJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_repli_id": "12701918312",
  "custom_google_gtm_id": "GTM-WLS9V7DS",
  "custom_rollout_phase": "Batch 3",
  "custom_vibesites_theme": "Vantage",
  "custom_ads_subscription": "essential",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/8a7d8f02-5be2-41aa-86cb-8cb1d2be93fa/app.js?nocache=1&gaTracking=G-5ZJF3NH02Y&buttonbgcolor=000000&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>",
  "custom_seo_subscription": "essential",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_ppc_tracking_phone_number": "816-992-5097",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjNyWHFCZ0c3OS84Tit2TGUvNXZySGc9PSIsInZhbHVlIjoieFdqSWlCSG9vYm4weWZEK0lZcUdwdz09IiwibWFjIjoiN2ZjMDk5ZjUwNGYzN2M4Y2NmYzRiNjY5ZDNlYTQyMGI5M2ZjZDE5MmIxYTAzMDI4NjdhMmRkNjgwZWYyMTUzMiJ9",
  "custom_audioeye_site_id": "971f542f-bc25-45ad-9719-86c3a319fe4d",
  "custom_audioeye_site_hash": "1b5c2f7216a4d7a39c78d0857007b7eb"
};

export const generatedAt = '2026-11-03T23:00:37.609Z';
